(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentDialogController', ShipmentDialogController);

    ShipmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', '$state', 'entity', 'Shipment', 'Invoice', 'RequiredDocument', 'ActivityHistory', 'Comment', 'Lot', 'Contract',
        'ToastrService', 'ContractCustomService', 'Principal', 'KeywordCustomService', '$uibModal', 'CommentCustomService', 'AttachmentCustomService', 'LotCustomService',
        'ShipmentCustomService', 'CompanyCustomService', 'LocationCustomService', '$rootScope', 'MiscService','ShipmentDocumentCustomService',
        'ShipmentDocument','RequiredDocumentCustomService', 'DateUtils','FreightPaymentCustomService','FreightPayment'];

    function ShipmentDialogController($timeout, $scope, $stateParams, $q, $state, entity, Shipment, Invoice, RequiredDocument, ActivityHistory, Comment, Lot, Contract,
                                      ToastrService, ContractCustomService, Principal, KeywordCustomService, $uibModal, CommentCustomService, AttachmentCustomService, LotCustomService,
                                      ShipmentCustomService, CompanyCustomService, LocationCustomService, $rootScope, MiscService, ShipmentDocumentCustomService,
                                      ShipmentDocument, RequiredDocumentCustomService, DateUtils, FreightPaymentCustomService, FreightPayment) {

        var vm = this;

        vm.shipment = entity;

        //function implementation
        vm.checkContracts = checkContracts;
        vm.addAnotherPurchaseContract = addAnotherPurchaseContract;
        vm.computeShipmentQty = computeShipmentQty;
        vm.refreshContractList = refreshContractList;
        vm.removePurchaseContract = removePurchaseContract;
        vm.autoContractQtyDisplayAs = autoContractQtyDisplayAs;
        vm.enterNewCompany = enterNewCompany;
        vm.enterNewLocation = enterNewLocation;
        vm.fetchLocations = fetchLocations;
        vm.resolveBoePayToDisplay = resolveBoePayToDisplay;
        vm.applyQtyUnitType = applyQtyUnitType;
        vm.applyBoeCurrency = applyBoeCurrency;
        vm.resolveBoeAmountDisplay = resolveBoeAmountDisplay;
        vm.onTextClick = onTextClick;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.calculateAvgNet = calculateAvgNet;
        vm.countBales = countBales;
        vm.applyLotUnitType = applyLotUnitType;
        vm.applyDropdownValue = applyDropdownValue;
        vm.toWords = toWords;
        vm.setScale = setScale;
        vm.smartUpdateWeights = smartUpdateWeights;
        vm.nl2br = MiscService.nl2br;

        //defaults
        vm.comment = "";
        vm.altQty = "";

        //details tab defaults
        vm.purchaseCount = 1;
        vm.disableAddPurchaseContract = true;
        vm.showAddPurchaseContract = false;
        vm.showContractB = false;
        vm.showContractC = false;
        vm.showContractD = false;
        vm.showContractE = false;
        vm.showContractF = false;
        vm.showLcSection = true; //change this to false to hide lc section on this form
        vm.showPaymentTypeError = false;
        vm.showUnitTypeError = false;
        vm.disableBoePayToLocationField = false;

        //lots tab defaults
        vm.showLotActions = false;
        vm.totalBalance = 0;
        vm.contractABal = 0;
        vm.contractBBal = 0;
        vm.contractCBal = 0;
        vm.contractDBal = 0;
        vm.contractEBal = 0;
        vm.contractFBal = 0;

        //Lists
        vm.shipmentStatuses = ['DRAFT', 'ALLOCATED', 'SCHEDULED', 'DRAFTRECEIVED', 'SHIPPED', 'INVOICED', 'CANCELLED'];
        vm.unitTypes = ['BALES', 'MTS'];
        vm.boeCurrencyList = ['USD', 'OTHER'];
        vm.purchaseContractAList = [];
        vm.purchaseContractBList = [];
        vm.purchaseContractCList = [];
        vm.purchaseContractDList = [];
        vm.purchaseContractEList = [];
        vm.purchaseContractFList = [];
        vm.saleContractList = [];
        vm.lots = [];
        vm.comments = [];
        vm.attachments = [];
        vm.issuers = [];
        vm.iLocationList = [];
        vm.boePayTos = [];
        vm.boePayToLocList = [];
        vm.blTos = [];
        vm.blFroms = [];
        vm.monthList = [];
        vm.audits = [];
        vm.invoiceNumber = '';
        vm.freightPaymentList = [];
        vm.fpTotalUsd = 0;
        vm.fpTotalEur = 0;

        vm.wtBasises = [];
        // KeywordCustomService.returnKeywordsByType("WtBasis").then(function (data) {
        KeywordCustomService.returnMinifiedKeywordsByType("WtBasis").then(function (data) {
            vm.wtBasises = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.paymentTerms = [];
        // KeywordCustomService.returnKeywordsByType("PaymentTerms").then(function (data) {
        KeywordCustomService.returnMinifiedKeywordsByType("PaymentTerms").then(function (data) {
            vm.paymentTerms = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        //=========================Start of shipment defaults======================
        //resolve other stuff if shipment exists
        if (vm.shipment.id === null) {
            vm.shipment.myUuid = generateUUID();
            vm.shipment.quantity = 0;
            vm.shipment.status = "DRAFT";
            vm.shipment.boeCurrency = "USD";
            vm.shipment.boeAmount = 0.00;
            vm.shipment.contract = null;
            vm.shipment.contractB = null;
            vm.shipment.contractC = null;
            vm.shipment.contractD = null;
            vm.shipment.contractE = null;
            vm.shipment.contractF = null;
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.shipment.createdBy = account.login;
                vm.shipment.modifiedBy = account.login;
            }, function (error) {
                ToastrService.error("Failed to get user", "Error!");
                console.log(error.status, error.statusText);
            });
            fetchPurchaseContractListByType("PURCHASE", "a");
            fetchPurchaseContractListByType("SALE");
            fetchCompanies();
            fetchMonthList();
            if($stateParams.fpId && $stateParams.fpId > 0) {
                FreightPaymentCustomService.returnFreightPaymentInfoForNewShipment($stateParams.fpId).then(function(data) {
                    vm.freightPaymentList.push(data.data);
                    getFpTotals();
                    if(data.data.id !== undefined) {
                        vm.shipment.blNumber = data.data.blNumber;
                        vm.shipment.shipmentBookingNumber = data.data.shipmentBookingNumber;
                    }
                }, function(error) {
                    ToastrService.error("Failed to fetch Freight Payment Information");
                });
            }
        } else { //shipment exists
            vm.shipmentCompany = vm.shipment.shipmentCompany;
            fetchPurchaseContractListByType("PURCHASE", "a");
            fetchPurchaseContractListByType("SALE");
            fetchMonthList();
            fetchCompanies();
            if (vm.shipment.contract !== undefined && vm.shipment.contract !== null) {
                vm.showLotActions = true;
            }
            if( vm.shipment.contractB !== null && vm.shipment.contractB !== undefined ) {
                fetchPurchaseContractListByType("PURCHASE", "b");
                vm.showContractB = true;
            }
            if( vm.shipment.contractC !== null && vm.shipment.contractC !== undefined ) {
                fetchPurchaseContractListByType( "PURCHASE", "c" );
                vm.showContractC = true;
            }
            if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined) {
                fetchPurchaseContractListByType("PURCHASE","d");
                vm.showContractD = true;
            }
            if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined) {
                fetchPurchaseContractListByType("PURCHASE","e");
                vm.showContractE = true;
            }
            if(vm.shipment.contractF !== null && vm.shipment.contractF !== undefined) {
                fetchPurchaseContractListByType("PURCHASE","f");
                vm.showContractF = true;
            }
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.shipment.modifiedBy = account.login;
            }, function (error) {
                ToastrService.error("Failed to get user", "Error!");
                console.log(error.status, error.statusText);
            });
            resolveShipmentDocument(vm.shipment.id);
            resolveFreightPayments(vm.shipment.id);
            resolveComments();
            resolveAttachments();
            resolveLots();
            resolveLrs();
            checkContracts();
            if( vm.shipment.boePayTo !== null && vm.shipment.boePayTo !== undefined ) {
                vm.fetchLocations(vm.shipment.boePayTo.id, 'payTo')
            }
            ShipmentCustomService.returnInvoiceNumber(vm.shipment.id).then(function (data) {
               if (data.data && data.data.id > 0) {
                   vm.invoiceNumber = data.data.ncontractInvNumber;
                   if(vm.shipment.boeRef === null) {
                       vm.shipment.boeRef = vm.invoiceNumber;
                   }
               }
            }, function (error) {
                console.log(error.status, error.statusText);
            });
        }

        function fetchMonthList() {
            ShipmentCustomService.returnMonthList().then(function (data) {
                vm.monthList = data.data;
            }, function (error) {
                vm.monthList = [];
                if (error.status !== "404") {
                    ToastrService.error("Failed to fetch Month List", "Error!");
                }
            });
        }

        function resolveShipmentDocument(id) {
            ShipmentDocumentCustomService.getShipmentDocumentByShipmentId(id).then(function(data) {
                vm.shipment.shipmentDocument = data.data;
                resolveRequiredDocument();
            }, function(error) {
                if(error.status !== "404") {
                    ToastrService.error("Failed to fetch Shipment Document", "Error!");
                }
            });
        }

        function resolveRequiredDocument() {
            vm.requiredDocuments = {
                purchaseInvoice: {},
                saleInvoice: {},
                icInvoice: {},
                bl: {},
                pl: {},
                wc: {},
                phyto: {},
                wr: {},
                co: {},
                ic: {},
                sc: {},
                fumigation: {}
            }
            if(vm.shipment.shipmentDocument.purchaseInvoice) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "PURCHASEINVOICE");
            }
            if(vm.shipment.shipmentDocument.saleInvoice) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "SALEINVOICE");
            }
            if(vm.shipment.shipmentDocument.icInvoice) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "ICINVOICE");
            }
            if(vm.shipment.shipmentDocument.bl) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "BL");
            }
            if(vm.shipment.shipmentDocument.pl) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "PL");
            }
            if(vm.shipment.shipmentDocument.wc) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "WC");
            }
            if(vm.shipment.shipmentDocument.phyto) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "PHYTO");
            }
            if(vm.shipment.shipmentDocument.wr) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "WR");
            }
            if(vm.shipment.shipmentDocument.co) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "CO");
            }
            if(vm.shipment.shipmentDocument.ic) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "IC");
            }
            if(vm.shipment.shipmentDocument.sc) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "SC");
            }
            if(vm.shipment.shipmentDocument.fumigation) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "FUMIGATION");
            }
        }

        //=========================End of shipment defaults========================
        //####################################################################
        //===========================Start of Calendar Stuff=======================
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.siDate = false;
        vm.datePickerOpenStatus.originEtd = false;
        vm.datePickerOpenStatus.destEta = false;
        vm.datePickerOpenStatus.freightPaymentDate = false;
        vm.datePickerOpenStatus.cutoff = false;
        vm.datePickerOpenStatus.blDate = false;
        vm.datePickerOpenStatus.lcDate = false;
        vm.datePickerOpenStatus.lcExpiry = false;
        vm.datePickerOpenStatus.lcLatestShipment = false;
        vm.datePickerOpenStatus.boeDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function applyLotUnitType(lot, unitType) {
            var weightData = vm.resolveWeightData(lot);
            lot.purchWtType = unitType;
            assignWeights(lot, weightData);
        }

        //==========================End of Calendar Stuff==================================
        //####################################################################
        //=========================Start of Contract Stuff=================================
        function fetchPurchaseContractListByType(type, which) {
            switch (type) {
                case 'PURCHASE':
                    vm.purchaseContractAList.length = 0;
                    ContractCustomService.returnMinifiedContractsByType(type).then(function (data) {
                        switch (which) {
                            case 'a':
                                vm.purchaseContractAList = data.data;
                                if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined) {
                                    var index = vm.purchaseContractAList.map(function (contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractB.id);
                                    vm.purchaseContractAList.splice(index, 1);
                                }
                                if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined) {
                                    var index = vm.purchaseContractAList.map(function (contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractC.id);
                                    vm.purchaseContractAList.splice(index, 1);
                                }
                                if (vm.purchaseContractAList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract List is Empty", "Warning");
                                }
                                break;
                            case 'b':
                                vm.purchaseContractBList = data.data;
                                var index = vm.purchaseContractBList.map(function (contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractBList.splice(index, 1);
                                if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined) {
                                    var index = vm.purchaseContractBList.map(function (contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractC.id);
                                    vm.purchaseContractBList.splice(index, 1);
                                }
                                if (vm.purchaseContractBList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract B List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract B List is Empty", "Warning");
                                }
                                break;
                            case 'c':
                                vm.purchaseContractCList = data.data;
                                var index = vm.purchaseContractCList.map(function (contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractCList.splice(index, 1);
                                index = vm.purchaseContractCList.map(function (contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractCList.splice(index, 1);
                                if (vm.purchaseContractCList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract C List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract C List is Empty", "Warning");
                                    vm.showContractC = false;
                                }
                                break;
                            case 'd':
                                vm.purchaseContractDList = data.data;
                                var index = vm.purchaseContractDList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractDList.splice(index, 1);
                                index = vm.purchaseContractDList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractDList.splice(index, 1);
                                index = vm.purchaseContractDList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractC.id);
                                vm.purchaseContractDList.splice(index, 1);
                                if(vm.purchaseContractDList.length > 0) {
                                    // ToastrService.success("Fetch Purchase Contract D List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract D List is Empty", "Warning");
                                    vm.showContractD = false;
                                }
                                break;
                            case 'e':
                                vm.purchaseContractEList = data.data;
                                var index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractEList.splice(index, 1);
                                index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractEList.splice(index, 1);
                                index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractC.id);
                                vm.purchaseContractEList.splice(index, 1);
                                index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractD.id);
                                vm.purchaseContractEList.splice(index, 1);
                                if(vm.purchaseContractEList.length > 0) {
                                    // ToastrService.success("Fetch Purchase Contract E List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract E List is Empty", "Warning");
                                    vm.showContractE = false;
                                }
                                break;
                            case 'f':
                                vm.purchaseContractFList = data.data;
                                var index = vm.purchaseContractFList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractFList.splice(index, 1);
                                index = vm.purchaseContractFList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractFList.splice(index, 1);
                                index = vm.purchaseContractFList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractC.id);
                                vm.purchaseContractFList.splice(index, 1);
                                index = vm.purchaseContractFList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractD.id);
                                vm.purchaseContractFList.splice(index, 1);
                                index = vm.purchaseContractFList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractE.id);
                                vm.purchaseContractFList.splice(index, 1);
                                if(vm.purchaseContractFList.length > 0) {

                                } else {
                                    ToastrService.warning("Purchase Contract F List is Empty", "Warning");
                                    vm.showContractF = false;
                                }
                                break;
                        }
                    }, function (error) {
                        if (error.status !== "404") {
                            ToastrService.error("Failed to fetch Purchase Contracts", "Error!");
                            console.log(error.status, error.statusText);
                        }
                    });
                    break;
                case 'SALE':
                    vm.saleContractList.length = 0;
                    // ContractCustomService.returnContractsByTypeAndStatus(type, "ISSUED").then(function (data) {
                    ContractCustomService.returnMinifiedContractsByType(type).then(function (data) {
                        vm.saleContractList = data.data;
                        if (vm.saleContractList.length > 0) {
                            // ToastrService.success("Fetched Sale Contract List", "Success!");
                        } else {
                            ToastrService.warning("Sale Contract List is Empty", "Warning");
                        }
                    }, function (error) {
                        if (error.status !== "404") {
                            ToastrService.error("Failed to fetch Sale Contracts", "Error!");
                            console.log(error.status, error.statusText);
                        }
                    });
                    break;
            }
        }

        function addAnotherPurchaseContract() {
            if(vm.showContractE) {
                fetchPurchaseContractListByType("PURCHASE","f");
                vm.showContractF = true;
                vm.showAddPurchaseContract = false;
            } else if(vm.showContractD) {
                fetchPurchaseContractListByType("PURCHASE","e");
                vm.showContractE = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            } else if(vm.showContractC) {
                fetchPurchaseContractListByType("PURCHASE","d");
                vm.showContractD = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            } else if(vm.showContractB) {
                fetchPurchaseContractListByType("PURCHASE","c");
                vm.showContractC = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            } else {
                fetchPurchaseContractListByType("PURCHASE","b");
                vm.showContractB = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function removePurchaseContract(which) {
            switch (which) {
                case 'b':
                    if(vm.showContractC) {
                        if(null != vm.shipment.contractC) {
                            xferContractCtoContractB();
                        }
                        if(vm.showContractD) {
                            if(null != vm.shipment.contractD) {
                                xferContractDtoContractC();
                            }
                            if(vm.showContractE) {
                                if(null != vm.shipment.contractE) {
                                    xferContractEtoContractD();
                                }
                                if(vm.showContractF) {
                                    if(null != vm.shipment.contractF) {
                                        xferContractFtoContractE();
                                    }
                                    resetContractF();
                                } else {
                                    resetContractE();
                                }
                            } else {
                                resetContractD();
                            }
                        } else {
                            resetContractC();
                        }
                    } else {
                        resetContractB();
                    }
                    break;
                case 'c':
                    if(vm.showContractD) {
                        if(null != vm.shipment.contractD) {
                            xferContractDtoContractC();
                        }
                        if(vm.showContractE) {
                            if(null != vm.shipment.contractE) {
                                xferContractEtoContractD();
                            }
                            if(vm.showContractF) {
                                if(null != vm.shipment.contractF) {
                                    xferContractFtoContractE();
                                }
                                resetContractF();
                            } else {
                                resetContractE();
                            }
                        } else {
                            resetContractD();
                        }
                    } else {
                        resetContractC();
                    }
                    break;
                case 'd':
                    if(vm.showContractE) {
                        if(null != vm.shipment.contractE) {
                            xferContractEtoContractD();
                        }
                        if(vm.showContractF) {
                            if(null != vm.shipment.contractF) {
                                xferContractFtoContractE();
                            }
                            resetContractF();
                        } else {
                            resetContractE();
                        }
                    } else {
                        resetContractD();
                    }
                    break;
                case 'e':
                    if(vm.showContractF) {
                        if(null != vm.shipment.contractF) {
                            xferContractFtoContractE();
                        }
                        resetContractF();
                    } else {
                        resetContractE();
                    }
                    break;
                case 'f':
                    resetContractF();
                    break;
            }
            checkContracts();
        }

        function refreshContractList(which) {
            switch (which) {
                case 'a':
                    fetchPurchaseContractListByType("PURCHASE", "a");
                    break;
                case 'b':
                    fetchPurchaseContractListByType("PURCHASE", "b");
                    break;
                case 'c':
                    fetchPurchaseContractListByType("PURCHASE", "c");
                    break;
                case 'd':
                    fetchPurchaseContractListByType("PURCHASE","d");
                    break;
                case 'e':
                    fetchPurchaseContractListByType("PURCHASE","e");
                    break;
                case 'f':
                    fetchPurchaseContractListByType("PURCHASE","f");
                    break;
                case 'sale':
                    fetchPurchaseContractListByType("SALE");
                    break;
            }
        }

        function applyContractQtyToShipmentQtyIfZero() {
            if (vm.shipment.contract !== null && vm.shipment.contract !== undefined && ( vm.shipment.quantityContractA === 0 || vm.shipment.quantityContractA === null ) ) {
                LotCustomService.returnAvailableQtyByPurchContract( vm.shipment.contract.id ).then( function( result ) {
                    vm.shipment.quantityContractA = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function( error ) {
                    vm.shipment.quantityContractA = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error( "Failed to get Available Qty for Contract " + vm.shipment.contract.contractNum );
                    console.log( JSON.stringify( error ) );
                });
            }
            if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined && ( vm.shipment.quantityContractB === 0 || vm.shipment.quantityContractB === null ) ) {
                LotCustomService.returnAvailableQtyByPurchContract( vm.shipment.contractB.id ).then( function( result ) {
                    vm.shipment.quantityContractB = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function( error ) {
                    vm.shipment.quantityContractB = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error( "Failed to get Available Qty for Contract " + vm.shipment.contractB.contractNum );
                    console.log( JSON.stringify( error ) );
                });
            }
            if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined && ( vm.shipment.quantityContractC === 0 || vm.shipment.quantityContractC === null ) ) {
                LotCustomService.returnAvailableQtyByPurchContract( vm.shipment.contractC.id ).then( function( result ) {
                    vm.shipment.quantityContractC = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function( error ) {
                    vm.shipment.quantityContractC = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error( "Failed to get Available Qty for Contract " + vm.shipment.contractC.contractNum );
                    console.log( JSON.stringify( error ) );
                });
            }
            if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined && (vm.shipment.quantityContractD === 0 || vm.shipment.quantityContractD === null)) {
                LotCustomService.returnAvailableQtyByPurchContract(vm.shipment.contractD.id).then(function(result) {
                    vm.shipment.quantityContractD = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function(error) {
                    vm.shipment.quantityContractD = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error("Failed to get Available Qty for Contract " + vm.shipment.contractD.contractNum);
                    console.log(JSON.stringify(error));
                });
            }
            if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined && (vm.shipment.quantityContractE === 0 || vm.shipment.quantityContractE === null)) {
                LotCustomService.returnAvailableQtyByPurchContract(vm.shipment.contractE.id).then(function(result) {
                    vm.shipment.quantityContractE = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function(error) {
                    vm.shipment.quantityContractE = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error("Failed to get Available Qty for Contract " + vm.shipment.contractE.contractNum);
                    console.log(JSON.stringify(error));
                });
            }
            if(vm.shipment.contractF !== null && vm.shipment.contractF !== undefined && (vm.shipment.quantityContractF === 0 || vm.shipment.quantityContractF === null)) {
                LotCustomService.returnAvailableQtyByPurchContract(vm.shipment.contractF.id).then(function(result) {
                    vm.shipment.quantityContractF = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function(error) {
                    vm.shipment.quantityContractF = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error("Failed to get Available Qty for Contract " + vm.shipment.contractF.contractNum);
                    console.log(JSON.stringify(error));
                })
            }
            if( vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined && (vm.shipment.quantitySaleContract === 0 || vm.shipment.quantitySaleContract === null)) {
                LotCustomService.returnAvailableQtyBySaleContract( vm.shipment.saleContract.id ).then( function( result ) {
                    vm.shipment.quantitySaleContract = result.data;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                }, function( error ) {
                    vm.shipment.quantitySaleContract = 0;
                    computeShipmentQty();
                    autoGenerateQtyDisplayAsIfNull();
                    ToastrService.error( "Failed to get Available Qty for Sale Contract " + vm.shipment.saleContract.contractNum );
                    console.log( JSON.stringify( error ) );
                });
            }
        }

        function autoGenerateQtyDisplayAsIfNull() {
            if (vm.shipment.contract !== null && vm.shipment.contract !== undefined && vm.shipment.qtyDisplayContractA === null) {
                vm.shipment.qtyDisplayContractA = vm.shipment.quantityContractA + " " + vm.shipment.contract.qtyUnitType;
            }
            if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined && vm.shipment.qtyDisplayContractB === null) {
                vm.shipment.qtyDisplayContractB = vm.shipment.quantityContractB + " " + vm.shipment.contractB.qtyUnitType;
            }
            if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined && vm.shipment.qtyDisplayContractC === null) {
                vm.shipment.qtyDisplayContractC = vm.shipment.quantityContractC + " " + vm.shipment.contractC.qtyUnitType;
            }
            if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined && vm.shipment.qtyDisplayContractD === null) {
                vm.shipment.qtyDisplayContractD = vm.shipment.quantityContractD + " " + vm.shipment.contractD.qtyUnitType;
            }
            if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined && vm.shipment.qtyDisplayContractE === null) {
                vm.shipment.qtyDisplayContractE = vm.shipment.quantityContractE + " " + vm.shipment.contractE.qtyUnitType;
            }
            if(vm.shipment.contractF !== null && vm.shipment.contractF !== undefined && vm.shipment.qtyDisplayContractF === null) {
                vm.shipment.qtyDisplayContractF = vm.shipment.quantityContractF + " " + vm.shipment.contractF.qtyUnitType;
            }
            if( vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined && vm.shipment.qtyDisplaySaleContract === null) {
                vm.shipment.qtyDisplaySaleContract = vm.shipment.quantitySaleContract + " " + vm.shipment.saleContract.qtyUnitType;
            }
        }

        function computeShipmentQty() {
            if (isNaN(vm.shipment.quantityContractA)) {
                vm.shipment.quantityContractA = 0;
            }
            if (isNaN(vm.shipment.quantityContractB)) {
                vm.shipment.quantityContractB = 0;
            }
            if (isNaN(vm.shipment.quantityContractC)) {
                vm.shipment.quantityContractC = 0;
            }
            if(isNaN(vm.shipment.quantityContractD)) {
                vm.shipment.quantityContractD = 0;
            }
            if(isNaN(vm.shipment.quantityContractE)) {
                vm.shipment.quantityContractE = 0;
            }
            if(isNaN(vm.shipment.quantityContractF)) {
                vm.shipment.quantityContractF = 0;
            }
            if (isNaN(vm.shipment.quantitySaleContract)) {
                vm.shipment.quantitySaleContract = 0;
            }
        }

        function resetContractB() {
            vm.shipment.contractB = null;
            vm.shipment.quantityContractB = 0;
            vm.shipment.qtyBalesContractB = 0;
            vm.shipment.qtyMtsContractB = 0;
            vm.shipment.qtyLbsContractB = 0;
            vm.shipment.qtyKgsContractB = 0;
            vm.shipment.qtyDisplayContractB = null;
            vm.showContractB = false;
            if (vm.shipment.contract !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractC() {
            vm.shipment.contractC = null;
            vm.shipment.quantityContractC = 0;
            vm.shipment.qtyBalesContractC = 0;
            vm.shipment.qtyMtsContractC = 0;
            vm.shipment.qtyLbsContractC = 0;
            vm.shipment.qtyKgsContractC = 0;
            vm.shipment.qtyDisplayContractC = null;
            vm.showContractC = false;
            if (vm.shipment.contractB !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractD() {
            vm.shipment.contractD = null;
            vm.shipment.quantityContractD = 0;
            vm.shipment.qtyBalesContractD = 0;
            vm.shipment.qtyMtsContractD = 0;
            vm.shipment.qtyLbsContractD = 0;
            vm.shipment.qtyKgsContractD = 0;
            vm.shipment.qtyDisplayContractD = null;
            vm.showContractD = false;
            if (vm.shipment.contractC !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractE() {
            vm.shipment.contractE = null;
            vm.shipment.quantityContractE = 0;
            vm.shipment.qtyBalesContractE = 0;
            vm.shipment.qtyMtsContractE = 0;
            vm.shipment.qtyLbsContractE = 0;
            vm.shipment.qtyKgsContractE = 0;
            vm.shipment.qtyDisplayContractE = null;
            vm.showContractE = false;
            if (vm.shipment.contractD !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractF() {
            vm.shipment.contractF = null;
            vm.shipment.quantityContractF = 0;
            vm.shipment.qtyBalesContractF = 0;
            vm.shipment.qtyMtsContractF = 0;
            vm.shipment.qtyLbsContractF = 0;
            vm.shipment.qtyKgsContractF = 0;
            vm.shipment.qtyDisplayContractF = null;
            vm.showContractF = false;
            if(vm.shipment.contractF !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function xferContractCtoContractB() {
            vm.shipment.contractB = vm.shipment.contractC;
            vm.shipment.quantityContractB = vm.shipment.quantityContractC;
            vm.shipment.qtyBalesContractB = vm.shipment.qtyBalesContractC;
            vm.shipment.qtyMtsContractB = vm.shipment.qtyMtsContractC;
            vm.shipment.qtyLbsContractB = vm.shipment.qtyLbsContractC;
            vm.shipment.qtyKgsContractB = vm.shipment.qtyKgsContractC;
            vm.shipment.qtyDisplayContractB = vm.shipment.qtyDisplayContractC;
        }

        function xferContractDtoContractC() {
            vm.shipment.contractC = vm.shipment.contractD;
            vm.shipment.quantityContractC = vm.shipment.quantityContractD;
            vm.shipment.qtyBalesContractC = vm.shipment.qtyBalesContractD;
            vm.shipment.qtyMtsContractC = vm.shipment.qtyMtsContractD;
            vm.shipment.qtyLbsContractC = vm.shipment.qtyLbsContractD;
            vm.shipment.qtyKgsContractC = vm.shipment.qtyKgsContractD;
            vm.shipment.qtyDisplayContractC = vm.shipment.qtyDisplayContractD;
        }

        function xferContractEtoContractD() {
            vm.shipment.contractD = vm.shipment.contractE;
            vm.shipment.quantityContractD = vm.shipment.quantityContractE;
            vm.shipment.qtyBalesContractD = vm.shipment.qtyBalesContractE;
            vm.shipment.qtyMtsContractD = vm.shipment.qtyMtsContractE;
            vm.shipment.qtyLbsContractD = vm.shipment.qtyLbsContractE;
            vm.shipment.qtyKgsContractD = vm.shipment.qtyKgsContractE;
            vm.shipment.qtyDisplayContractD = vm.shipment.qtyDisplayContractE;
        }

        function xferContractFtoContractE() {
            vm.shipment.contractE = vm.shipment.contractF;
            vm.shipment.quantityContractE = vm.shipment.quantityContractF;
            vm.shipment.qtyBalesContractE = vm.shipment.qtyBalesContractF;
            vm.shipment.qtyMtsContractE = vm.shipment.qtyMtsContractF;
            vm.shipment.qtyLbsContractE = vm.shipment.qtyLbsContractF;
            vm.shipment.qtyKgsContractE = vm.shipment.qtyKgsContractF;
            vm.shipment.qtyDisplayContractE = vm.shipment.qtyDisplayContractF;
        }

        function checkContracts() {
            if (vm.shipment.contract !== null || vm.shipment.saleContract !== null ) {
                applyContractQtyToShipmentQtyIfZero();
                vm.disableAddPurchaseContract = false;
                if (!vm.showContractB && vm.shipment.contractB === null) {
                    vm.disableAddPurchaseContract = false;
                } else {
                    if (!vm.showContractC && vm.shipment.contractB !== null) {
                        vm.disableAddPurchaseContract = false;
                    } else {
                        if(!vm.showContractD && vm.shipment.contractC !== null) {
                            vm.disableAddPurchaseContract = false;
                        } else {
                            if(!vm.showContractE && vm.shipment.contractD !== null) {
                                vm.disableAddPurchaseContract = false;
                            } else {
                                if(!vm.showContractF && vm.shipment.contractE !== null) {
                                    vm.disableAddPurchaseContract = false;
                                } else {
                                    vm.disableAddPurchaseContract = true;
                                }
                            }
                        }
                    }
                }
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
                // if (!vm.showContractB && vm.shipment.contractB === null) {
                //     vm.disableAddPurchaseContract = false;
                // } else {
                //     if (!vm.showContractC && vm.shipment.contractB !== null) {
                //         vm.disableAddPurchaseContract = false;
                //     } else {
                //         vm.disableAddPurchaseContract = true;
                //     }
                // }
                if( vm.shipment.saleContract !== null && ( vm.shipment.drawee === null || vm.shipment.drawee === "" ) ) {
                    if( vm.shipment.saleContract.subCategory === "JAPAN" ) {
                        if( vm.shipment.saleContract.outsideBuyer !== undefined && vm.shipment.saleContract.outsideBuyer !== null ) {
                            vm.shipment.drawee = vm.shipment.saleContract.outsideBuyer.name;
                        } else if( vm.shipment.saleContract.buyer !== undefined && vm.shipment.saleContract.buyer !== null ) {
                            vm.shipment.drawee = vm.shipment.saleContract.buyer.name;
                        }
                    } else {
                        if( vm.shipment.saleContract.outsideBuyer !== undefined && vm.shipment.saleContract.outsideBuyer !== null ) {
                            vm.shipment.drawee = vm.shipment.saleContract.outsideBuyer.name;
                        }
                    }
                }
                vm.showPaymentTypeError = false;
                vm.showLotActions = true;
                vm.showLcSection = true;
                CompanyCustomService.returnCompaniesByType('BANK').then( function( data ) {
                    vm.issuers = data.data;
                    vm.boePayTo = data.data;
                    // if( vm.issuers.length > 0 ) {
                    //     ToastrService.success( "Fetched Bank List", "Success!" );
                    // }
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Failed to get Bank List: " + error.statusText, "Error!" );
                    }
                });
                countBales();
            } else {
                vm.disableAddPurchaseContract = true;
                vm.showLcSection = false;
                vm.issuers.length = 0;
                vm.iLocationList.length = 0;
                vm.boePayTos.length = 0;
                vm.boePayToLocList.length = 0;
                vm.showLotActions = false;
            }
        }

        function autoContractQtyDisplayAs(which) {
            switch (which) {
                case 'a':
                    vm.shipment.qtyDisplayContractA = vm.shipment.quantityContractA + " " + vm.shipment.contract.qtyUnitType;
                    break;
                case 'b':
                    vm.shipment.qtyDisplayContractB = vm.shipment.quantityContractB + " " + vm.shipment.contractB.qtyUnitType;
                    break;
                case 'c':
                    vm.shipment.qtyDisplayContractC = vm.shipment.quantityContractC + " " + vm.shipment.contractC.qtyUnitType;
                    break;
                case 'd':
                    vm.shipment.qtyDisplayContractD = vm.shipment.quantityContractD + " " + vm.shipment.contractD.qtyUnitType;
                    break;
                case 'e':
                    vm.shipment.qtyDisplayContractE = vm.shipment.quantityContractE + " " + vm.shipment.contractE.qtyUnitType;
                    break;
                case 'f':
                    vm.shipment.qtyDisplayContractF = vm.shipment.quantityContractF + " " + vm.shipment.contractF.qtyUnitType;
                    break;
                case 'sale':
                    vm.shipment.qtyDisplaySaleContract = vm.shipment.quantitySaleContract + " " + vm.shipment.saleContract.qtyUnitType;
                    break;
            }
        }

        //=========================End of Contract Stuff===================================
        //####################################################################
        //=========================Start of Shipment Detail Stuff==========================
        vm.shipmentCompanyList = [];
        vm.shipmentCompany = "";
        // KeywordCustomService.returnKeywordsByType("Shipment Company").then(function (data) {
        KeywordCustomService.returnMinifiedKeywordsByType("Shipment Company").then(function (data) {
            vm.shipmentCompanyList = data.data;
            if( vm.shipmentCompanyList.length > 0 ) {
                // ToastrService.success("Grabbed Shipment Companies Success", "Success!");
                if (vm.shipment.id && vm.shipment.id > 0) {
                    for (var i = 0; i < vm.shipmentCompanyList.length; i++) {
                        if (vm.shipmentCompanyList[i].keyword === vm.shipment.shipmentCompany) {
                            vm.shipmentCompany = vm.shipmentCompanyList[i];
                            break;
                        }
                    }
                }
            }
        }, function (error) {
            if( error.status !== "404" ) {
                ToastrService.error("Failed to get Shipment Companies", "Error!");
            }
            console.log( error.message );
        });

        vm.tenorsList = [];
        vm.boeTenor = "";
        KeywordCustomService.returnMinifiedKeywordsByType("Tenor").then(function (data) {
            vm.tenorsList = data.data;
            // if( vm.shipmentCompanyList.length > 0 ) {
            //     ToastrService.success("Grabbed Tenors Success", "Success!");
            // }
        }, function (error) {
            if( error.status !== "404" ) {
                ToastrService.error("Failed to get Tenors", "Error!");
            }
            console.log( error.message );
        });

        vm.draweeList = [];
        KeywordCustomService.returnMinifiedKeywordsByType("Drawee").then( function( data ) {
            vm.draweeList = data.data;
            if( vm.draweeList.length > 0 ) {
                // ToastrService.success("Grabbed Shipment Drawee Success", "Success!");
                if(vm.shipment.id && vm.shipment.id > 0) {
                    for (var i = 0; i < vm.draweeList.length; i++) {
                        if (vm.draweeList[i].keyword === vm.shipment.drawee) {
                            vm.shipment.drawee = vm.draweeList[i].keyword;
                            break;
                        }
                    }
                }
            }
        }, function( error ) {
            if( error.status !== "404" ) {
                ToastrService.error("Failed to get Shipment Drawee", "Error!");
            }
            console.log(error.message);
        });

        vm.collectThroughList = [];
        KeywordCustomService.returnMinifiedKeywordsByType("CollectThrough").then( function( data ) {
            vm.collectThroughList = data.data;
            if( vm.collectThroughList.length > 0 ) {
                // ToastrService.success( "Grabbed Shipment Collect Through List Success", "Success!" );
                if( vm.shipment.id && vm.shipment.id > 0 ) {
                    for( var i = 0; i < vm.collectThroughList.length; i++ ) {
                        if( vm.collectThroughList[i].keyword === vm.shipment.collectThrough ) {
                            vm.shipment.collectThrough = vm.collectThroughList[i].keyword;
                            break;
                        }
                    }
                }
            }
        }, function( error ) {
            if( error.status !== "404" ) {
                ToastrService.error("Failed to get Shipment Collect Through List", "Error!");
            }
            console.log( error.message );
        });

        function applyDropdownValue(type, value) {
            if (type && value) {
                switch (type) {
                    case "BL From":
                        vm.shipment.blFrom = value;
                        break;
                    case "BL To":
                        vm.shipment.blTo = value;
                        break;
                    case "Drawee":
                        vm.shipment.drawee = value;
                        break;
                    case "CollectThrough":
                        vm.shipment.collectThrough = value;
                    default:
                        break;
                }
            }
        }

        vm.applyShipmentCompany = function() {
            vm.shipment.shipmentCompany = vm.shipmentCompany.keyword;
        };

        vm.applyTenor = function() {
            vm.shipment.boeTenor = vm.boeTenor.keyword;
        };

        //TODO -- check if this method will still be used, if not, deprecate this mofo
        if ($stateParams.paramId !== undefined && $stateParams.paramId !== null) {
            ContractCustomService.returnContractById($stateParams.paramId).then(function (response) {
                // ToastrService.success("Grabbed Param Contract", "Success!");
                vm.shipment.contract = response.data;
                vm.shipment.qtyUnitType = vm.shipment.contract.qtyUnitType;
                vm.showLcSection = vm.shipment.contract.paymentType === "LC";
            }, function (error) {
                ToastrService.error("Failed to get param Contract", "Error!");
                vm.showLcSection = false;
                console.log(error.status, error.statusText);
            });
        }

        vm.enterNewKeyword = function (type) {
            $uibModal.open({
                templateUrl: 'app/entities/keyword/keyword-dialog.html',
                controller: 'KeywordDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: vm.account.login,
                            modifiedOn: new Date(),
                            modifiedBy: vm.account.login,
                            type: type,
                            value: null,
                            desc: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                switch (type) {
                    case 'Tenor':
                        vm.tenorsList.push(retVal);
                        vm.shipment.boeTenor = retVal.keyword;
                        vm.boeTenor = retVal;
                        break;
                    case 'Controller':
                        vm.controllerList.push(retVal);
                        vm.shipment.controller = retVal.keyword;
                        break;
                    case 'Shipment Company':
                        vm.shipmentCompanyList.push(retVal);
                        vm.shipment.shipmentCompany = retVal.keyword;
                        vm.shipmentCompany = retVal;
                        break;
                    case 'Drawee':
                        vm.draweeList.push(retVal);
                        vm.shipment.drawee = retVal.keyword;
                        break;
                    case 'CollectThrough':
                        vm.collectThroughList.push(retVal);
                        vm.shipment.collectThrough = retVal.keyword;
                    case 'BL From':
                        vm.blFromList.push( retVal );
                        vm.shipment.blFrom = retVal.keyword;
                        break;
                    case 'BL To':
                        vm.blToList.push( retVal );
                        vm.shipment.blTo = retVal.keyword;
                        break;
                    case 'WtBasis' :
                        vm.wtBasises.push(retVal);
                        vm.shipment.wtBasis = retVal.keyword;
                        vm.shipment.wtBasisDisplay = vm.shipment.wtBasis;
                        break;
                    case 'PaymentTerms' :
                        vm.paymentTerms.push(retVal);
                        vm.shipment.paymentTerms = retVal.keyword;
                        vm.shipment.paymentTermsDisplay = vm.shipment.paymentTerms;
                        break;
                }
            });
        };

        vm.applyKeyword = function (type) {
            switch (type) {
                case 'Shipment Company':
                    vm.shipment.shipmentCompany = vm.shipmentCompany.keyword;
                    break;
            }
        };

        vm.applyCurrencyType = applyCurrencyType;
        vm.generateInvoiceAmountDisplay = generateInvoiceAmountDisplay;
        vm.applySiDateToBlDate = applySiDateToBlDate;

        function applyCurrencyType(type) {
            vm.shipment.freightInvoiceCurrency = type;
            generateInvoiceAmountDisplay();
        }

        function generateInvoiceAmountDisplay() {
            var invoiceAmountDisplay = "";
            if(vm.shipment.freightInvoiceAmount) {
                invoiceAmountDisplay += vm.shipment.freightInvoiceAmount;
            }
            if(vm.shipment.freightInvoiceCurrency) {
                invoiceAmountDisplay = invoiceAmountDisplay + " ";
                invoiceAmountDisplay = invoiceAmountDisplay + vm.shipment.freightInvoiceCurrency;
            }
            vm.shipment.freightInvoiceAmountDisplay = invoiceAmountDisplay;
        }

        function applySiDateToBlDate() {
            vm.shipment.blDate = vm.shipment.siDate;
        }

        //=========================End of Shipment Detail Stuff============================
        //####################################################################
        //=========================Start of BL Section==============================
        //TODO -- this is not applied to the front end yet
        function fetchBlTos() {
            vm.blTos.length = 0;
            // KeywordCustomService.returnKeywordsByType("BL To").then(function (data) {
            KeywordCustomService.returnMinifiedKeywordsByType("BL To").then(function (data) {
                vm.blTos = data.data;
                // if (vm.blTos.length > 0) {
                //     ToastrService.success("Fetch Tos list", "Success");
                // }
            }, function (error) {
                if (error.status != "404") {
                    ToastrService.error("Failed to fetch List of Tos", "Error!");
                    console.log(error.status, error.statusText);
                }
            });
        }

        //TODO -- this is not applied to the front end yet
        function fetchBlFroms() {
            vm.blFroms.length = 0;
            // KeywordCustomService.returnKeywordsByType("BL From").then(function (data) {
            KeywordCustomService.returnMinifiedKeywordsByType("BL From").then(function (data) {
                vm.blFroms = data.data;
                // if (vm.blFroms.length > 0) {
                //     ToastrService.success("Fetch Froms list", "Success");
                // }
            }, function (error) {
                if (error.status != "404") {
                    ToastrService.error("Failed to fetch List of Froms", "Error!");
                    console.log(error.status, error.statusText);
                }
            });
        }

        //========================End of BL Section============================
        //####################################################################
        //========================Start of Freight Payments Section===========
        vm.fetchFreightPaymentsWithNoShipmentByBlNumber = fetchFreightPaymentsWithNoShipmentByBlNumber;
        vm.openNewFreightPaymentOnCreate = openNewFreightPaymentOnCreate;
        vm.openNewFreightPayment = openNewFreightPayment;
        vm.openEditFreightPayment = openEditFreightPayment;

        function resolveFreightPayments(id) {
            vm.freightPaymentList = [];
            FreightPaymentCustomService.returnFreightPaymentsByShipment(id).then(function(data) {
                vm.freightPaymentList = data.data;
                getFpTotals();
            }, function(error) {
                ToastrService.error("Failed to get Freight Payments");
            });
        }

        function fetchFreightPaymentsWithNoShipmentByBlNumber() {
            FreightPaymentCustomService.returnFreightPaymentsWithNoShipmentByBlNumber(vm.shipment.blNumber).then(function(data) {
                if(data.data.length > 0) {
                    angular.forEach(data.data, function(value, key) {
                        if(vm.freightPaymentList.length > 0) {
                            var index = vm.freightPaymentList.indexOf(value);
                            vm.freightPaymentList[index] = value;
                        } else {
                            vm.freightPaymentList.push(value);
                        }
                    });
                }
                getFpTotals();
            }, function(error) {
                ToastrService.error("Failed to get Freight Payments");
            });
        }

        function getFpTotals() {
            vm.fpTotalUsd = 0;
            vm.fpTotalEur = 0;
            if(vm.freightPaymentList.length > 0) {
                angular.forEach(vm.freightPaymentList, function(value, key) {
                   if(value.invoiceCurrency === "USD") {
                       vm.fpTotalUsd += value.invoiceAmount;
                   } else {
                       vm.fpTotalEur += value.invoiceAmount;
                   }
                });
            }
        }

        function openNewFreightPaymentOnCreate() {
            $uibModal.open({
                templateUrl: 'app/entities/freight-payment/modal/freight-payment-shipment-dialog.html',
                controller: 'FreightPaymentShipmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdBy: 'admin',
                            createdOn: new Date(),
                            modifiedBy: 'admin',
                            modifiedOn: new Date(),
                            paymentDate: new Date(),
                            invoiceAmount: 0,
                            invoiceCurrency: 'USD',
                            invoiceAmountDisplay: '0 USD',
                            shipmentBookingNumber: vm.shipment.shipmentBookingNumber,
                            blNumber: vm.shipment.blNumber,
                            comment: null
                        }
                    },
                    shipmentPage: function() {
                        return true;
                    },
                    shipmentId: function() {
                        return null;
                    }
                }
            }).result.then(function(val) {
                vm.freightPaymentList.push(val);
                getFpTotals();
            }, function() {
                ToastrService.error("Something went wrong when saving Freight Payment");
            });
        }

        function openNewFreightPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/freight-payment/modal/freight-payment-shipment-dialog.html',
                controller: 'FreightPaymentShipmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdBy: 'admin',
                            createdOn: new Date(),
                            modifiedBy: 'admin',
                            modifiedOn: new Date(),
                            paymentDate: new Date(),
                            invoiceAmount: 0,
                            invoiceCurrency: 'USD',
                            invoiceAmountDisplay: '0 USD',
                            shipmentBookingNumber: vm.shipment.shipmentBookingNumber,
                            blNumber: vm.shipment.blNumber,
                            comment: null
                        }
                    },
                    shipmentPage: function() {
                        return true;
                    },
                    shipmentId: function() {
                        return vm.shipment.id
                    }
                }
            }).result.then(function() {
                resolveFreightPayments(vm.shipment.id);
            }, function() {
                resolveFreightPayments(vm.shipment.id);
            })
        }

        function openEditFreightPayment(index) {
            $uibModal.open({
                templateUrl: 'app/entities/freight-payment/modal/freight-payment-shipment-dialog.html',
                controller: 'FreightPaymentShipmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        if(vm.freightPaymentList[index].id && vm.freightPaymentList[index].id !== null && vm.freightPaymentList[index].id > 0) {
                            return FreightPayment.get({id: vm.freightPaymentList[index].id}).$promise;
                        } else {
                            return vm.freightPaymentList[index];
                        }
                    },
                    shipmentPage: function() {
                        return true;
                    },
                    shipmentId: function() {
                        return vm.shipment.id;
                    }
                }
            }).result.then(function(result) {
                if(vm.shipment.id && vm.shipment.id > 0) {
                    resolveFreightPayments(vm.shipment.id);
                } else {
                    vm.freightPaymentList[index] = result;
                    getFpTotals();
                }
            }, function() {
                if(vm.shipment.id && vm.shipment.id > 0) {
                    resolveFreightPayments(vm.shipment.id);
                }
            });
        }
        //========================End of Freight Payments Section=============
        //####################################################################
        //========================Start of LC and BoE Section========================
        //entering a new Company for issuedBy and PayTo
        function enterNewCompany(type, which) {
            $uibModal.open({
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: vm.account.login,
                            modifiedOn: new Date(),
                            modifiedBy: vm.account.login,
                            type: type.toUpperCase(),
                            name: null,
                            accountNum: null,
                            locations: null
                        }
                    },
                    showTypes: function() {
                        return true;
                    }
                }
            }).result.then(function (retVal) {
                switch (which) {
                    case 'payTo':
                        vm.boePayTos.push(retVal);
                        vm.shipment.boePayTo = retVal;
                        $timeout(function () {
                            angular.element(document.querySelector('#field_boePayToLocation')).focus();
                        });
                        enterNewLocation(vm.shipment.boePayTo, which);
                        break;
                }
            })
        }

        //entering a new location based on the company chosen on either issuedBy or PayTo
        function enterNewLocation(company, which) {
            $uibModal.open({
                templateUrl: 'app/entities/location/location-dialog.html',
                controller: 'LocationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: vm.account.login,
                            modifiedOn: new Date(),
                            modifiedBy: vm.account.login,
                            name: null,
                            address1: null,
                            address2: null,
                            address3: null,
                            address4: null,
                            addressDisplay: null,
                            country: null,
                            phone: null,
                            fax: null,
                            company: company
                        }
                    }
                }
            }).result.then(function (retVal) {
                switch (which) {
                    case 'payTo':
                        vm.boePayToLocList.push(retVal);
                        vm.shipment.boePayToLocation = retVal;
                        vm.disableBoePayToLocationField = false;
                        resolveBoePayToDisplay(company, vm.shipment.boePayToLocation);
                        break;
                }
            })
        }

        //fetch locations based on the company chosen on either issuedBy or PayTo
        function fetchLocations(id, which) {
            if (id !== null && id !== undefined) {
                LocationCustomService.returnLocationsByCompany(id).then(function (result) {
                    switch (which) {
                        case 'payTo':
                            vm.boePayToLocList.length = 0;
                            vm.boePayToLocList = result.data;
                            if (vm.shipment.id && vm.shipment.id > 0 && vm.boePayToLocList.length > 0 && vm.shipment.boePayToLocation) {
                                for (var i = 0; i < vm.boePayToLocList.length; i++) {
                                    if (vm.boePayToLocList[i].id === vm.shipment.boePayToLocation.id) {
                                        vm.shipment.boePayToLocation = vm.boePayToLocList[i];
                                        break;
                                    }
                                }
                            }
                            vm.disableBoePayToLocationField = false;
                            break;
                    }
                }, function (error) {
                    if (error.status !== "404") {
                        ToastrService.error("Failed to fetch Locations", "Error!");
                        switch (which) {
                            case 'payTo':
                                vm.boePayToLocList.length = 0;
                                vm.disableBoePayToLocationField = true;
                                break;
                        }
                    }
                });
            }
        }

        //fetch companies
        function fetchCompanies() {
            CompanyCustomService.returnCompaniesByType('BANK').then(function (result) {
                vm.issuers = result.data;
                vm.boePayTos = result.data;
                // if( vm.issuers.length > 0 ) {
                //     ToastrService.success("Fetched Bank List", "Success!");
                // }
                if (vm.shipment.id && vm.shipment.id > 0 && vm.boePayTos.length > 0 ) {
                    if(vm.shipment.boePayTo !== null && vm.shipment.boePayTo !== undefined) {
                        for (var i = 0; i < vm.boePayTos.length; i++) {
                            if (vm.boePayTos[i].id === vm.shipment.boePayTo.id) {
                                vm.shipment.boePayTo = vm.boePayTos[i];
                                break;
                            }
                        }
                    }
                }
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Failed to get Bank List", "Error!");
                }
                console.log( error.message );
            });
        }

        vm.resolveLcDescriptionDisplay = function () {
            vm.shipment.lcDescriptionDisplay = vm.shipment.lcDescription;
        };

        //just to update BoE Pay To Display
        function resolveBoePayToDisplay(company, location) {
            var displayAs = "";
            if (!vm.disableBoePayToLocationField) {
                displayAs = company.name;
                if (location && location !== null) {
                    if (location.country && location.country !== null && location.country.length > 0) {
                        if (location.address3 && location.address3 !== null && location.address3.length > 0) {
                            displayAs = displayAs + ", " + location.address3;
                        }
                        displayAs = displayAs + ", " + location.country;
                    }
                }
            }
            vm.shipment.boePayToDisplay = displayAs;
        }

        function applyQtyUnitType(val) {
            vm.shipment.qtyUnitType = val;
            resolveShipmentQtyDisplay();
        }

        function resolveShipmentQtyDisplay() {
            if( !vm.shipment.quantity || vm.shipment.quantity === null || vm.shipment.quantity.length === 0) {
                vm.shipment.quantity = 0;
            }
            vm.shipment.qtyDisplay = vm.shipment.quantity + " " + vm.shipment.qtyUnitType;
        }

        function applyBoeCurrency(val) {
            vm.shipment.boeCurrency = val;
            resolveBoeAmountDisplay();
        }

        function resolveBoeAmountDisplay() {
            if (!vm.shipment.boeAmount || vm.shipment.boeAmount === null || vm.shipment.boeAmount.length === 0) {
                vm.shipment.boeAmount = 0.00;
            }
            vm.shipment.boeAmountDisplay = vm.shipment.boeCurrency + " " + vm.shipment.boeAmount;
            vm.shipment.boeAmountText = toWords( vm.shipment.boeAmount );
        }

        //=========================End of LC and BoE Section===========================
        //####################################################################
        //========================Start of Lot Functions========================
        vm.viewLotDetails = function (lot) {
            $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-detail-modal.html',
                controller: 'LotDetailModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return lot;
                    }
                }
            }).result.then(function (retVal) {

            });
        };

        vm.viewSplitLotModal = function (lot, index) {
            $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-split-modal.html',
                controller: 'LotSplitModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    myLot: function () {
                        return lot;
                    }
                }
            }).result.then(function (lots) {
                ToastrService.success("Successfully split Lot", "Success!");
                if (vm.shipment.id > 0) {
                    resolveLots();
                } else {
                    if (lots.constructor === Array) {
                        var prom1 = resolveALot(lots[0]);
                        var prom2 = resolveALot(lots[1]);
                        prom1.then(function(result) {
                            vm.lots[index] = result;
                        });
                        prom2.then(function(result) {
                            vm.lots.push(result);
                        });
                    } else {
                        var prom = resolveALot(lots);
                        prom.then(function(result) {
                            vm.lots[index] = result;
                        });

                    }
                    countBales();
                }
            });
        };

        vm.verifyUnallocateLot = function (lot, index) {
            $uibModal.open({
                templateUrl: 'app/entities/lot/dialog/lot-unallocate-dialog.html',
                controller: 'LotUnallocateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return lot;
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    ToastrService.success("Successfully unallocated Lot", "Success!");
                    vm.lots.splice(index, 1);
                    countBales();
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        };

        vm.verifyRemoveUnsavedLot = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/lot/dialog/lot-unsaved-remove-dialog.html',
                controller: 'LotUnsavedRemoveDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        // return vm.shipment.lots[ index ];
                        return vm.lots[index];
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal === true ) {
                    ToastrService.success( "Successfully removed Lot", "Success!" );
                    vm.lots.splice(index, 1);
                    countBales();
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        };

        vm.refreshLotList = function () {
            resolveLots();
        };

        vm.viewLotSearchModal = function () {
            $uibModal.open({
                templateUrl: 'app/entities/lot/dialog/lot-search-dialog.html',
                controller: 'LotSearchDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    siEntity: function () {
                        return vm.shipment;
                    },
                    contractEntity: function () {
                        return vm.shipment.contract;
                    },
                    contractEntityB: function () {
                        return vm.shipment.contractB;
                    },
                    contractEntityC: function () {
                        return vm.shipment.contractC;
                    },
                    contractEntityD: function() {
                        return vm.shipment.contractD;
                    },
                    contractEntityE: function() {
                        return vm.shipment.contractE;
                    },
                    contractEntityF: function() {
                        return vm.shipment.contractF;
                    },
                    saleContractEntity: function () {
                        return vm.shipment.saleContract;
                    },
                    allocatedLots: function() {
                        return vm.lots;
                    }
                }
            }).result.then(function (retVal) {
                if (retVal.length > 0) {
                    var allocatedLotsIds = getAllocatedIds();
                    angular.forEach(retVal, function (value, key) {
                        if (allocatedLotsIds.indexOf(value.id) < 0) {
                            vm.lots.push(value);
                        }
                    });
                    if( vm.shipment.status === "DRAFT" || vm.shipment.status === "DRAFTRECEIVED" ) {
                        // vm.shipment.status = "ALLOCATED";
                    }
                }
                countBales();
            });
        };

        function getAllocatedIds() {
            var allocatedLotsIds = [];
            if (vm.allocatedLots) {
                for (var i = 0; i < vm.lots.length; i++) {
                    allocatedLotsIds.push(vm.lots[i].id);
                }
            }
            return allocatedLotsIds;
        }

        vm.viewImportLotModal = function () {
            $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-import-modal.html',
                controller: 'LotImportModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    contractEntity: function () {
                        return vm.shipment.contract;
                    },
                    contractBEntity: function () {
                        return vm.shipment.contractB;
                    },
                    contractCEntity: function () {
                        return vm.shipment.contractC;
                    },
                    contractDEntity: function() {
                        return vm.shipment.contractD;
                    },
                    contractEEntity: function() {
                        return vm.shipment.contractE
                    },
                    contractFEntity: function() {
                        return vm.shipment.contractF
                    },
                    siEntity: function () {
                        return vm.shipment;
                    },
                    saleContractEntity: function () {
                        return vm.shipment.saleContract;
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal.length > 0 ) {
                    if(vm.shipment.id !== null) {
                        resolveLots();
                    } else {
                        angular.forEach( retVal, function( value, key ) {
                            vm.lots.push( retVal[key] );
                        });
                    }
                    if( vm.shipment.status !== "ALLOCATED" ) {
                        // vm.shipment.status = "ALLOCATED";
                    }
                }
            });
        };

        vm.viewCreateNewLotModal = function () {
            $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-form-modal.html',
                controller: 'LotFormModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    contractEntity: function () {
                        return vm.shipment.contract;
                    },
                    contractBEntity: function () {
                        return vm.shipment.contractB;
                    },
                    contractCEntity: function () {
                        return vm.shipment.contractC;
                    },
                    contractDEntity: function() {
                        return vm.shipment.contractD;
                    },
                    contractEEntity: function() {
                        return vm.shipment.contractE;
                    },
                    contractFEntity: function() {
                        return vm.shipment.contractF;
                    },
                    siEntity: function () {
                        return vm.shipment;
                    },
                    saleContractEntity: function () {
                        return vm.shipment.saleContract;
                    }
                }
            }).result.then(function (retVal) {
                if (retVal) {
                    if(vm.shipment.id !== null) {
                        resolveLots();
                    } else {
                        vm.lots.push(retVal);
                        countBales();
                    }
                    if( vm.shipment.status !== "ALLOCATED" ) {
                        // vm.shipment.status = "ALLOCATED";
                    }
                }
            });
        };

        function countBales() {
            vm.totalBalance = 0;
            vm.contractABal = 0;
            vm.contractBBal = 0;
            vm.contractCBal = 0;
            vm.contractDBal = 0;
            vm.contractEBal = 0;
            vm.contractFBal = 0;
            vm.contractAQtyBal = 0;
            vm.contractBQtyBal = 0;
            vm.contractCQtyBal = 0;
            vm.contractDQtyBal = 0;
            vm.contractEQtyBal = 0;
            vm.contractFQtyBal = 0;
            angular.forEach(vm.lots, function (value, key) {
                if (vm.shipment.contract !== null && vm.shipment.contract !== undefined && vm.shipment.contract.id === value.purchase.id) {
                    vm.contractABal += returnMyValue(value);
                    vm.contractAQtyBal += returnMyQtyValue( vm.shipment.contract.qtyUnitType, value );
                }
                if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined && vm.shipment.contractB.id === value.purchase.id) {
                    vm.contractBBal += returnMyValue(value);
                    vm.contractBQtyBal += returnMyQtyValue( vm.shipment.contractB.qtyUnitType, value );
                }
                if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined && vm.shipment.contractC.id === value.purchase.id) {
                    vm.contractCBal += returnMyValue(value);
                    vm.contractCQtyBal += returnMyQtyValue( vm.shipment.contractC.qtyUnitType, value );
                }
                if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined && vm.shipment.contractD.id === value.purchase.id) {
                    vm.contractDBal += returnMyValue(value);
                    vm.contractDQtyBal += returnMyQtyValue(vm.shipment.contractD.qtyUnitType, value);
                }
                if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined && vm.shipment.contractE.id === value.purchase.id) {
                    vm.contractEBal += returnMyValue(value);
                    vm.contractEQtyBal += returnMyQtyValue(vm.shipment.contractE.qtyUnitType, value);
                }
                if(vm.shipment.contractF !== null && vm.shipment.contractF !== undefined && vm.shipment.contractF.id === value.purchase.id) {
                    vm.contractFBal += returnMyValue(value);
                    vm.contractFQtyBal += returnMyQtyValue(vm.shipment.contractF.qtyUnitType, value);
                }
                vm.totalBalance += returnMyValue(value);
            });
        }

        function returnMyValue( value ) {
            if( vm.shipment.qtyUnitType !== undefined && vm.shipment.qtyUnitType !== null ) {
                switch( vm.shipment.qtyUnitType ) {
                    case 'KGS':
                        return value.purchLandedNetKgs;
                        break;
                    case 'LBS':
                        return value.purchLandedNetLbs;
                        break;
                    case 'MTS':
                        return value.purchLandedNetMTs;
                        break;
                    default:
                        return value.qtyBales;
                        break;
                }
            } else {
                return 0;
            }
        }

        function returnMyQtyValue(qtyUnitType, value) {
            switch(qtyUnitType) {
                case 'BALES':
                    return value.qtyBales;
                    break;
                default:
                    return value.purchLandedNetMTs;
                    break
            }
        }

        function smartUpdateWeights() {
            if(vm.lots.length > 0) {
                var lotIds = [];
                for(var x = 0; x < vm.lots.length; x++) {
                    lotIds[x] = vm.lots[x].id;
                }
                $uibModal.open({
                    templateUrl: 'app/entities/lot/modal/lot-smart-weight-update-modal.html',
                    controller: 'LotSmartWeightUpdateModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        lotList: function() {
                            return vm.lots;
                        }
                    }
                }).result.then(function() {
                    if(vm.shipment.id) {
                        resolveLots();
                    } else {
                        vm.lots = [];
                        LotCustomService.returnMinifiedLotIds(lotIds).then(function(data) {
                            vm.lots = data.data;
                            resolveLotData();
                        }, function(error) {
                            ToastrService.error("Failed to fetch Lots");
                        });
                    }
                });
            }
        }

        function resolveLotData() {
            if(vm.lots.length > 0) {
                var promise = [];
                angular.forEach(vm.lots, function(value, key) {
                    //set sale stuff
                    if(vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined) {
                        vm.lots[key].allocSale = vm.shipment.saleContract;
                        if(vm.shipment.id !== null) {
                            vm.lots[key].allocSi = vm.shipment;
                        }
                    }
                    //set purchase stuff
                    promise.push(
                        ContractCustomService.returnPurchaseContractByLot(vm.lots[key].id).then(function(data) {
                            vm.lots[key].purchase = data.data;
                        }, function(error) {
                            if(error.status !== "404") {
                                ToastrService.error("Failed to get purchase contract of Lot with id: " + vm.lots[key].id);
                            }
                            console.log(error.message);
                        })
                    );
                    if(vm.shipment.id !== null) {
                        vm.lots[key].purchSi = vm.shipment;
                    }
                });
                $q.all(promise).then(function() {
                    countBales();
                });
            }
        }

        //========================End of Lot Functions========================
        //####################################################################
        //======================Start of Comment Functions=====================
        vm.addComment = function () {
            if (vm.comment.length > 0) {
                if( vm.shipment.id !== null ) { //save comment immediately
                    var comment = [];
                    comment.push(createComment(vm.comment));
                    CommentCustomService.assignParentToComment(comment, vm.shipment.id, "shipment").then(function () {
                        ToastrService.success("Added Comment to Shipment", "Success!");
                        resolveComments();
                    }, function () {
                        ToastrService.error("Failed to Save Comment", "Error");
                    });
                } else { //push to array to be saved along with the shipment
                    vm.comments.push(createComment(vm.comment));
                    ToastrService.info("Added Comment to Shipment", "Info");
                }
                vm.comment = "";
            } else {
                console.log('Cannot add comment. vm.comment.length is not (> 0)');
            }
        };

        function createComment(comment) {
            return {
                "id": null,
                "createdOn": new Date(),
                "createdBy": vm.account.login,
                "modifiedOn": new Date(),
                "modifiedBy": vm.account.login,
                "comment": comment,
                "active": true
            };
        }

        vm.editComment = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.comments[index];
                    },
                    shipmentEntity: function () {
                        return Shipment.get({id: vm.shipment.id}).$promise;
                    },
                    contractEntity: function () {
                        return null;
                    },
                    lotEntity: function () {
                        return null;
                    },
                    invoiceEntity: function () {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function (retVal) {
                ToastrService.success("Successfully Updated Comment", "Success!");
                // vm.shipment.comments[ index ] = retVal;
                vm.comments[index] = retVal;
                // resolveComments();
            });
        };

        vm.editUnsavedComment = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-dialog.html',
                controller: 'CommentUnsavedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        // return vm.shipment.comments[index];
                        return vm.comments[index];
                    }
                }
            }).result.then(function (retVal) {
                ToastrService.success("Successfully Updated Comment", "Success!");
                // vm.shipment.comments[ index ] = retVal;
                vm.comments[index] = retVal;
            });
        };

        vm.showCommentAudit = function (id) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-audit-dialog.html',
                controller: 'CommentAuditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return Comment.get({id: id}).$promise;
                    }
                }
            }).result.then(function () {
                // resolveComments();
            });
        };

        vm.verifyCommentDelete = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return vm.comments[index];
                    },
                    shipmentEntity: function () {
                        return Shipment.get({id: vm.shipment.id}).$promise;
                    },
                    contractEntity: function () {
                        return null;
                    },
                    lotEntity: function () {
                        return null;
                    },
                    invoiceEntity: function () {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    ToastrService.success("Successfully deleted Comment", "Success!");
                    vm.comments.splice(index, 1);
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        };

        vm.verifyCommentUnsavedDelete = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-delete-dialog.html',
                controller: 'CommentUnsavedDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        // return vm.shipment.comments[ index ];
                        return vm.comments[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    ToastrService.success("Successfully deleted Comment", "Success!");
                    // vm.shipment.comments.splice( index, 1 );
                    vm.comments.splice(index, 1);
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        };

        //========================End of Comment Functions======================
        //####################################################################
        //=======================Start of Attachment Functions==================
        //attachment actions
        vm.deleteTempAttachment = deleteTempAttachment;
        vm.downloadAttachment = downloadAttachment;
        vm.deleteAttachment = deleteAttachment;
        //File Uploading
        $scope.files = [];
        $scope.uploadFile = function (file) {
            if( file && file.length ) {
                angular.forEach( file, function( file ) {
                    $scope.files.push( file );
                    if( vm.shipment.id !== null ) {
                        AttachmentCustomService.uploadAttachment( file, "shipment", vm.shipment.id, file.name ).then( function( data ) {
                            vm.attachments.push( data.data );
                            ToastrService.success( "Successfully uploaded attachment", "Success!" );
                        }, function( error ) {
                            if( error.status !== 404 ) {
                                ToastrService.error( "Something went wrong with the attachment: " + error.statusText, "Error" );
                            }
                            console.log( error.statusText );
                        });
                        var index = $scope.files.indexOf( file );
                        $scope.files.splice( index, 1 );
                    }
                });
            }
        };

        function deleteTempAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-remove-modal.html',
                controller: 'AttachmentRemoveModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return $scope.files[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    $scope.files.splice( index, 1 );
                    ToastrService.success("Successfully removed Attachment", "Success!");
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Something went wrong: " + error.statusText, "Error");
                    console.log( error.statusText );
                }
            });
        }

        function deleteAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.attachments[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    vm.attachments.splice( index, 1 );
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        //========================End of Attachment Functions===================
        //####################################################################
        //========================Start of Save========================
        function save() {
            vm.isSaving = true;
            if (vm.shipment.status === "DRAFT" && vm.lots.length > 0) {
                // vm.shipment.status = "ALLOCATED";
            }
            if (vm.shipment.id !== null) {
                Shipment.update(vm.shipment, onSaveSuccess, onSaveError);
            } else {
                Shipment.save(vm.shipment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            var newShimpent = vm.shipment.id === null;
            vm.shipment.id = result.id;
            if (newShimpent) {
                var promlist = [];
                if (vm.lots.length > 0) {
                    promlist.push(LotCustomService.assignShipmentToLots(vm.lots, result, vm.shipment.saleContract));
                }
                if (vm.comments.length > 0) {
                    var comments = [];
                    for (var x = 0; x < vm.comments.length; x++) {
                        if (vm.comments[x].id === null) {
                            comments.push(vm.comments[x]);
                        }
                    }
                    if (comments.length > 0) {
                        promlist.push(CommentCustomService.assignParentToComment(comments, vm.shipment.id, "shipment"));
                    }
                }
                if(vm.freightPaymentList.length > 0) {
                    for(var x = 0; x < vm.freightPaymentList.length; x++) {
                        if(vm.freightPaymentList[x].shipment === null || vm.freightPaymentList[x].shipment === undefined) {
                            vm.freightPaymentList[x].shipment = vm.shipment;
                            if(vm.freightPaymentList[x].id !== null) {
                                promlist.push(FreightPayment.update(vm.freightPaymentList[x]).$promise);
                            } else {
                                promlist.push(FreightPayment.save(vm.freightPaymentList[x]).$promise);
                            }
                        }
                    }
                }
                if ($scope.files.length > 0) {
                    angular.forEach($scope.files, function (file) {
                        promlist.push(AttachmentCustomService.uploadAttachment(file, "shipment", vm.shipment.id, file.name));
                    });
                }
                if (promlist.length > 0) {
                    $q.all(promlist).then(function () {
                        finalizeSave();
                    }).then(function () {
                        finalizeSave();
                    });
                } else {
                    finalizeSave();
                }
            } else {
                finalizeSave();
            }
        }

        function finalizeSave() {
            vm.isSaving = false;
            resolveDates();
            ToastrService.success("Shipment Save Success", "Success!");
            var data = {
                heading: 'Detail ' + vm.shipment.siNum,
                route: 'shipment.shipment-detail',
                id: vm.shipment.id,
                param: {}
            };
            $rootScope.$emit('handleEmit', data);
            $state.go('shipment.shipment-detail', {id: vm.shipment.id}, {reload: true});
        }

        function onSaveError() {
            ToastrService.error("Something went wrong", "Error");
            resolveDates();
            vm.isSaving = false;
        }

        //========================End of Save========================
        //####################################################################
        //========================Start of Shipment Document========================
        vm.shipmentDocumentOptions = [true, false];
        vm.toUpload = {
            purchaseInvoice: [],
            saleInvoice: [],
            icInvoice: [],
            bl: [],
            pl: [],
            wc: [],
            co: [],
            phyto: [],
            wr: [],
            ic: [],
            sc: [],
            fumigation: []
        }
        vm.rdComments = {
            purchaseInvoice: '',
            saleInvoice: '',
            icInvoice: '',
            bl: '',
            pl: '',
            wc: '',
            co: '',
            phyto: '',
            wr: '',
            ic: '',
            sc: '',
            fumigation: ''
        }

        vm.convertBoolean = convertBoolean;
        vm.updateShipmentDocument = updateShipmentDocument;
        vm.uploadFilesPurchaseInvoice = uploadFilesPurchaseInvoice;
        vm.uploadFilesSaleInvoice = uploadFilesSaleInvoice;
        vm.uploadFilesIcInvoice = uploadFilesIcInvoice;
        vm.uploadFilesBl = uploadFilesBl;
        vm.uploadFilesPl = uploadFilesPl;
        vm.uploadFilesWc = uploadFilesWc;
        vm.uploadFilesCo = uploadFilesCo;
        vm.uploadFilesPhyto = uploadFilesPhyto;
        vm.uploadFilesWr = uploadFilesWr;
        vm.uploadFilesIc = uploadFilesIc;
        vm.uploadFilesSc = uploadFilesSc;
        vm.uploadFilesFumigation = uploadFilesFumigation;
        vm.deleteTempRequiredDocument = deleteTempRequiredDocument;
        vm.deleteRequiredDocument = deleteRequiredDocument;
        vm.approveRequiredDocumentAttachment = approveRequiredDocumentAttachment;

        function convertBoolean(value) {
            return value === true ? 'Yes' : 'No';
        }

        function updateShipmentDocument(value, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.shipment.shipmentDocument.purchaseInvoice = value;
                    break;
                case 'SALEINVOICE':
                    vm.shipment.shipmentDocument.saleInvoice = value;
                    break;
                case 'ICINVOICE':
                    vm.shipment.shipmentDocument.icInvoice = value;
                    break;
                case 'BL':
                    vm.shipment.shipmentDocument.bl = value;
                    break;
                case 'PL':
                    vm.shipment.shipmentDocument.pl = value;
                    break;
                case 'WC':
                    vm.shipment.shipmentDocument.wc = value;
                    break;
                case 'CO':
                    vm.shipment.shipmentDocument.co = value;
                    break;
                case 'PHYTO':
                    vm.shipment.shipmentDocument.phyto = value;
                    break;
                case 'WR':
                    vm.shipment.shipmentDocument.wr = value;
                    break;
                case 'IC':
                    vm.shipment.shipmentDocument.ic = value;
                    break;
                case 'SC':
                    vm.shipment.shipmentDocument.sc = value;
                    break;
                case 'FUMIGATION':
                    vm.shipment.shipmentDocument.fumigation = value;
                    break;
            }
            if(vm.shipment.id !== null) {
                ShipmentDocument.update(vm.shipment.shipmentDocument, function(result) {
                    vm.shipment.shipmentDocument = result;
                }, function(error) {
                    ToastrService.error("Failed to update Shipment Document", "Error");
                });
            }
            if(value) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, type);
            }
        }

        function fetchRequiredDocument(sdId, type) {
            if(sdId == null) {
                //do nothing
                // applyRequiredDocument(createRequiredDocumentMemory(type), type);
            } else {
                RequiredDocumentCustomService.getRequiredDocumentByShipmentDocumentIdAndType(sdId, type).then(function(data) {
                    applyRequiredDocument(data.data, type);
                }, function(error) {
                    ToastrService.error("Failed to fetch Required Document for type: " + type, "Error!");
                });
            }
        }

        function applyRequiredDocument(value, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice = value;
                    vm.requiredDocuments.purchaseInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.purchaseInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.purchaseInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.purchaseInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice = value;
                    vm.requiredDocuments.saleInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.saleInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.saleInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.saleInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.saleInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.saleInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice = value;
                    vm.requiredDocuments.icInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.icInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.icInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.icInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.icInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.icInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'BL':
                    vm.requiredDocuments.bl = value;
                    vm.requiredDocuments.bl.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.bl.id, true).then(function(data) {
                        vm.requiredDocuments.bl.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Final Attachment", "Error");
                    });
                    vm.requiredDocuments.bl.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.bl.id, false).then(function(data) {
                        vm.requiredDocuments.bl.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'PL':
                    vm.requiredDocuments.pl = value;
                    vm.requiredDocuments.pl.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.pl.id, true).then(function(data) {
                        vm.requiredDocuments.pl.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Final Attachment", "Error");
                    });
                    vm.requiredDocuments.pl.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.pl.id, false).then(function(data) {
                        vm.requiredDocuments.pl.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'WC':
                    vm.requiredDocuments.wc = value;
                    vm.requiredDocuments.wc.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wc.id, true).then(function(data) {
                        vm.requiredDocuments.wc.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.wc.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wc.id, false).then(function(data) {
                        vm.requiredDocuments.wc.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'CO':
                    vm.requiredDocuments.co = value;
                    vm.requiredDocuments.co.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.co.id, true).then(function(data) {
                        vm.requiredDocuments.co.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Final Attachment", "Error");
                    });
                    vm.requiredDocuments.co.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.co.id, false).then(function(data) {
                        vm.requiredDocuments.co.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto = value;
                    vm.requiredDocuments.phyto.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.phyto.id, true).then(function(data) {
                        vm.requiredDocuments.phyto.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Final Attachment", "Error");
                    });
                    vm.requiredDocuments.phyto.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.phyto.id, false).then(function(data) {
                        vm.requiredDocuments.phyto.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'WR':
                    vm.requiredDocuments.wr = value;
                    vm.requiredDocuments.wr.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wr.id, true).then(function(data) {
                        vm.requiredDocuments.wr.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Final Attachment", "Error");
                    });
                    vm.requiredDocuments.wr.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wr.id, false).then(function(data) {
                        vm.requiredDocuments.wr.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'IC':
                    vm.requiredDocuments.ic = value;
                    vm.requiredDocuments.ic.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.ic.id, true).then(function(data) {
                        vm.requiredDocuments.ic.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.ic.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.ic.id, false).then(function(data) {
                        vm.requiredDocuments.ic.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'SC':
                    vm.requiredDocuments.sc = value;
                    vm.requiredDocuments.sc.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.sc.id, true).then(function(data) {
                        vm.requiredDocuments.sc.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.sc.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.sc.id, false).then(function(data) {
                        vm.requiredDocuments.sc.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation = value;
                    vm.requiredDocuments.fumigation.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.fumigation.id, true).then(function(data) {
                        vm.requiredDocuments.fumigation.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Fumigation Final Attachment", "Error");
                    });
                    vm.requiredDocuments.fumigation.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.fumigation.id, false).then(function(data) {
                        vm.requiredDocuments.fumigation.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Fumigation Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
            }
        }

        function uploadFilesPurchaseInvoice(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    vm.toUpload.purchaseInvoice.push(file);
                    if(vm.requiredDocuments.purchaseInvoice.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.purchaseInvoice.id,'PURCHASEINVOICE');
                        spliceFileFromToUpload(file, 'PURCHASEINVOICE');
                    }
                })
            }
        }

        function uploadFilesSaleInvoice(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.saleInvoice.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.saleInvoice.id,'SALEINVOICE');
                        spliceFileFromToUpload(file, 'SALEINVOICE');
                    }
                })
            }
        }

        function uploadFilesIcInvoice(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.icInvoice.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.icInvoice.id,'ICINVOICE');
                        spliceFileFromToUpload(file, 'ICINVOICE');
                    }
                })
            }
        }

        function uploadFilesBl(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.bl.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.bl.id,'BL');
                        spliceFileFromToUpload(file, 'BL');
                    }
                })
            }
        }

        function uploadFilesPl(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.pl.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.pl.id,'PL');
                        spliceFileFromToUpload(file, 'PL');
                    }
                })
            }
        }

        function uploadFilesWc(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.wc.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.wc.id,'WC');
                        spliceFileFromToUpload(file, 'WC');
                    }
                })
            }
        }

        function uploadFilesCo(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.co.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.co.id,'CO');
                        spliceFileFromToUpload(file, 'CO');
                    }
                })
            }
        }

        function uploadFilesPhyto(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.phyto.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.phyto.id,'PHYTO');
                        spliceFileFromToUpload(file, 'PHYTO');
                    }
                })
            }
        }

        function uploadFilesWr(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.wr.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.wr.id,'WR');
                        spliceFileFromToUpload(file, 'WR');
                    }
                })
            }
        }

        function uploadFilesIc(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.ic.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.ic.id,'IC');
                        spliceFileFromToUpload(file, 'IC');
                    }
                })
            }
        }

        function uploadFilesSc(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.sc.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.sc.id,'SC');
                        spliceFileFromToUpload(file, 'SC');
                    }
                })
            }
        }

        function uploadFilesFumigation(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.fumigation.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.fumigation.id,'FUMIGATION');
                        spliceFileFromToUpload(file, 'FUMIGATION');
                    }
                })
            }
        }

        function pushFileToRequiredDocument(file, type) {
            switch(type){
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.attachments.push(file);
                    vm.requiredDocuments.purchaseInvoice.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.purchaseInvoice.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.attachments.push(file);
                    vm.requiredDocuments.saleInvoice.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.saleInvoice.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.attachments.push(file);
                    vm.requiredDocuments.icInvoice.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.icInvoice.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.attachments.push(file);
                    vm.requiredDocuments.bl.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.bl.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.attachments.push(file);
                    vm.requiredDocuments.pl.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.pl.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.attachments.push(file);
                    vm.requiredDocuments.wc.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.wc.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'CO':
                    vm.requiredDocuments.co.attachments.push(file);
                    vm.requiredDocuments.co.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.co.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.attachments.push(file);
                    vm.requiredDocuments.phyto.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.phyto.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.attachments.push(file);
                    vm.requiredDocuments.wr.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.wr.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.attachments.push(file);
                    vm.requiredDocuments.ic.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.ic.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.attachments.push(file);
                    vm.requiredDocuments.sc.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.sc.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.attachments.push(file);
                    vm.requiredDocuments.fumigation.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.fumigation.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
            }
        }

        function uploadAttachmentRequiredDocument(file, id, type) {
            AttachmentCustomService.uploadAttachment(file, "required-document", id, file.name).then(function(data) {
                pushFileToRequiredDocument(data.data, type);
            }, function(error) {
                ToastrService.error("Failed to Upload " + file.name, "Error");
            });
        }

        function spliceFileFromToUpload(file, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    var index = vm.toUpload.purchaseInvoice.indexOf(file);
                    vm.toUpload.purchaseInvoice.splice(index,1);
                    break;
                case 'SALEINVOICE':
                    var index = vm.toUpload.saleInvoice.indexOf(file);
                    vm.toUpload.saleInvoice.splice(index,1);
                    break;
                case 'ICINVOICE':
                    var index = vm.toUpload.icInvoice.indexOf(file);
                    vm.toUpload.icInvoice.splice(index,1);
                    break;
                case 'BL':
                    var index = vm.toUpload.bl.indexOf(file);
                    vm.toUpload.bl.splice(index,1);
                    break;
                case 'PL':
                    var index = vm.toUpload.pl.indexOf(file);
                    vm.toUpload.pl.splice(index,1);
                    break;
                case 'WC':
                    var index = vm.toUpload.wc.indexOf(file);
                    vm.toUpload.wc.splice(index,1);
                    break;
                case 'CO':
                    var index = vm.toUpload.co.indexOf(file);
                    vm.toUpload.co.splice(index,1);
                    break;
                case 'PHYTO':
                    var index = vm.toUpload.phyto.indexOf(file);
                    vm.toUpload.phyto.splice(index,1);
                    break;
                case 'WR':
                    var index = vm.toUpload.wr.indexOf(file);
                    vm.toUpload.wr.splice(index,1);
                    break;
                case 'IC':
                    var index = vm.toUpload.ic.indexOf(file);
                    vm.toUpload.ic.splice(index,1);
                    break;
                case 'SC':
                    var index = vm.toUpload.sc.indexOf(file);
                    vm.toUpload.sc.splice(index,1);
                    break;
                case 'FUMIGATION':
                    var index = vm.toUpload.fumigation.indexOf(file);
                    vm.toUpload.fumigation.splice(index,1);
                    break;
            }
        }

        function deleteTempRequiredDocument(index, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.toUpload.purchaseInvoice.splice(index,1);
                    break;
                case 'SALEINVOICE':
                    vm.toUpload.saleInvoice.splice(index,1);
                    break;
                case 'ICINVOICE':
                    vm.toUpload.icInvoice.splice(index,1);
                    break;
                case 'BL':
                    vm.toUpload.bl.splice(index,1);
                    break;
                case 'PL':
                    vm.toUpload.pl.splice(index,1);
                    break;
                case 'WC':
                    vm.toUpload.wc.splice(index,1);
                    break;
                case 'CO':
                    vm.toUpload.co.splice(index,1);
                    break;
                case 'PHYTO':
                    vm.toUpload.phyto.splice(index,1);
                    break;
                case 'WR':
                    vm.toUpload.wr.splice(index,1);
                    break;
                case 'IC':
                    vm.toUpload.ic.splice(index,1);
                    break;
                case 'SC':
                    vm.toUpload.sc.splice(index,1);
                    break;
                case 'FUMIGATION':
                    vm.toUpload.fumigation.splice(index,1);
                    break;
            }
        }

        function spliceFileFromRequiredDocument(index, type, approved) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    if(approved) {
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments.splice(index, 1);
                        if(vm.requiredDocuments.purchaseInvoice.approvedAttachments.length === 0) {
                            vm.requiredDocuments.purchaseInvoice.approved = null;
                            if(vm.requiredDocuments.purchaseInvoice.attachments.length === 0) {
                                vm.requiredDocuments.purchaseInvoice.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.purchaseInvoice.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.purchaseInvoice.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.purchaseInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.purchaseInvoice.attachments.length === 0) {
                            vm.requiredDocuments.purchaseInvoice.received = null;
                            RequiredDocumentCustomService.resetReceivedDates(vm.requiredDocuments.purchaseInvoice.id);
                        }
                    }
                    break;
                case 'SALEINVOICE':
                    if(approved) {
                        vm.requiredDocuments.saleInvoice.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.saleInvoice.approvedAttachments.length === 0) {
                            vm.requiredDocuments.saleInvoice.approved = null;
                            if(vm.requiredDocuments.saleInvoice.attachments.length === 0) {
                                vm.requiredDocuments.saleInvoice.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.saleInvoice.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.saleInvoice.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.saleInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.saleInvoice.attachments.length === 0) {
                            vm.requiredDocuments.saleInvoice.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.saleInvoice.id);
                        }
                    }
                    break;
                case 'ICINVOICE':
                    if(approved) {
                        vm.requiredDocuments.icInvoice.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.icInvoice.approvedAttachments.length === 0) {
                            vm.requiredDocuments.icInvoice.approved = null;
                            if(vm.requiredDocuments.icInvoice.attachments.length === 0) {
                                vm.requiredDocuments.icInvoice.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.icInvoice.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.icInvoice.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.icInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.icInvoice.attachments.length === 0) {
                            vm.requiredDocuments.icInvoice.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.icInvoice.id);
                        }
                    }
                    break;
                case 'BL':
                    if(approved) {
                        vm.requiredDocuments.bl.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.bl.approvedAttachments.length === 0) {
                            vm.requiredDocuments.bl.approved = null;
                            if(vm.requiredDocuments.bl.attachments.length === 0) {
                                vm.requiredDocuments.bl.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.bl.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.bl.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.bl.attachments.splice(index,1);
                        if(vm.requiredDocuments.bl.attachments.length === 0) {
                            vm.requiredDocuments.bl.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.bl.id);
                        }
                    }
                    break;
                case 'PL':
                    if(approved) {
                        vm.requiredDocuments.pl.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.pl.approvedAttachments.length === 0) {
                            vm.requiredDocuments.pl.approved = null;
                            if(vm.requiredDocuments.pl.attachments.length === 0) {
                                vm.requiredDocuments.pl.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.pl.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.pl.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.pl.attachments.splice(index,1);
                        if(vm.requiredDocuments.pl.attachments.length === 0) {
                            vm.requiredDocuments.pl.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.pl.id);
                        }
                    }
                    break;
                case 'WC':
                    if(approved) {
                        vm.requiredDocuments.wc.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.wc.approvedAttachments.length === 0) {
                            vm.requiredDocuments.wc.approved = null;
                            if(vm.requiredDocuments.wc.attachments.length === 0) {
                                vm.requiredDocuments.wc.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.wc.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.wc.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.wc.attachments.splice(index,1);
                        if(vm.requiredDocuments.wc.attachments.length === 0) {
                            vm.requiredDocuments.wc.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.wc.id);
                        }
                    }
                    break;
                case 'CO':
                    if(approved) {
                        vm.requiredDocuments.co.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.co.approvedAttachments.length === 0) {
                            vm.requiredDocuments.co.approved = null;
                            if(vm.requiredDocuments.co.attachments.length === 0) {
                                vm.requiredDocuments.co.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.co.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.co.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.co.attachments.splice(index,1);
                        if(vm.requiredDocuments.co.attachments.length === 0) {
                            vm.requiredDocuments.co.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.co.id);
                        }
                    }
                    break;
                case 'PHYTO':
                    if(approved) {
                        vm.requiredDocuments.phyto.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.phyto.approvedAttachments.length === 0) {
                            vm.requiredDocuments.phyto.approved = null;
                            if(vm.requiredDocuments.phyto.attachments.length === 0) {
                                vm.requiredDocuments.phyto.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.phyto.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.phyto.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.phyto.attachments.splice(index,1);
                        if(vm.requiredDocuments.phyto.attachments.length === 0) {
                            vm.requiredDocuments.phyto.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.phyto.id);
                        }
                    }
                    break;
                case 'WR':
                    if(approved) {
                        vm.requiredDocuments.wr.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.wr.approvedAttachments.length === 0) {
                            vm.requiredDocuments.wr.approved = null;
                            if(vm.requiredDocuments.wr.attachments.length === 0) {
                                vm.requiredDocuments.wr.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.wr.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.wr.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.wr.attachments.splice(index,1);
                        if(vm.requiredDocuments.wr.attachments.length === 0) {
                            vm.requiredDocuments.wr.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.wr.id);
                        }
                    }
                    break;
                case 'IC':
                    if(approved) {
                        vm.requiredDocuments.ic.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.ic.approvedAttachments.length === 0) {
                            vm.requiredDocuments.ic.approved = null;
                            if(vm.requiredDocuments.ic.attachments.length === 0) {
                                vm.requiredDocuments.ic.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.ic.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.ic.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.ic.attachments.splice(index,1);
                        if(vm.requiredDocuments.ic.attachments.length === 0) {
                            vm.requiredDocuments.ic.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.ic.id);
                        }
                    }
                    break;
                case 'SC':
                    if(approved) {
                        vm.requiredDocuments.sc.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.sc.approvedAttachments.length === 0) {
                            vm.requiredDocuments.sc.approved = null;
                            if(vm.requiredDocuments.sc.attachments.length === 0) {
                                vm.requiredDocuments.sc.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.sc.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.sc.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.sc.attachments.splice(index,1);
                        if(vm.requiredDocuments.sc.attachments.length === 0) {
                            vm.requiredDocuments.sc.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.sc.id);
                        }
                    }
                    break;
                case 'FUMIGATION':
                    if(approved) {
                        vm.requiredDocuments.fumigation.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.fumigation.approvedAttachments.length === 0) {
                            vm.requiredDocuments.fumigation.approved = null;
                            if(vm.requiredDocuments.fumigation.attachments.length === 0) {
                                vm.requiredDocuments.fumigation.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.fumigation.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.fumigation.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.fumigation.attachments.splice(index,1);
                        if(vm.requiredDocuments.fumigation.attachments.length === 0) {
                            vm.requiredDocuments.fumigation.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.fumigation.id);
                        }
                    }
                    break;
            }
        }

        function deleteRequiredDocument(file, index, type, approved) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return file;
                    }
                }
            }).result.then(function(retVal) {
                if(retVal === true) {
                    spliceFileFromRequiredDocument(index, type, approved);
                } else {
                    ToastrService.error("Cannot delete Attachment", "Error");
                }
            });
        }

        function approveRequiredDocumentAttachment(attachment, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.purchaseInvoice.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.purchaseInvoice.attachments.indexOf(attachment);
                        vm.requiredDocuments.purchaseInvoice.attachments.splice(index, 1);
                        if(vm.requiredDocuments.purchaseInvoice.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.purchaseInvoice.approvedAttachments[0];
                            vm.requiredDocuments.purchaseInvoice.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments = [];
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Purchase Invoice Attachment", "Error");
                    });
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.saleInvoice.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.saleInvoice.attachments.indexOf(attachment);
                        vm.requiredDocuments.saleInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.saleInvoice.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.saleInvoice.approvedAttachments[0];
                            vm.requiredDocuments.saleInvoice.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.saleInvoice.approvedAttachments = [];
                        vm.requiredDocuments.saleInvoice.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Sale invoice Attachment", "Error");
                    });
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.icInvoice.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.icInvoice.attachments.indexOf(attachment);
                        vm.requiredDocuments.icInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.icInvoice.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.icInvoice.approvedAttachments[0];
                            vm.requiredDocuments.icInvoice.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.icInvoice.approvedAttachments = [];
                        vm.requiredDocuments.icInvoice.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve IC Invoice Attachment", "Error");
                    });
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.bl.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.bl.attachments.indexOf(attachment);
                        vm.requiredDocuments.bl.attachments.splice(index,1);
                        if(vm.requiredDocuments.bl.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.bl.approvedAttachments[0];
                            vm.requiredDocuments.bl.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.bl.approvedAttachments = [];
                        vm.requiredDocuments.bl.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve BL Attachment", "Error");
                    });
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.pl.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.pl.attachments.indexOf(attachment);
                        vm.requiredDocuments.pl.attachments.splice(index,1);
                        if(vm.requiredDocuments.pl.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.pl.approvedAttachments[0];
                            vm.requiredDocuments.pl.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.pl.approvedAttachments = [];
                        vm.requiredDocuments.pl.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve PL Attachment", "Error");
                    });
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.wc.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.wc.attachments.indexOf(attachment);
                        vm.requiredDocuments.wc.attachments.splice(index,1);
                        if(vm.requiredDocuments.wc.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.wc.approvedAttachments[0];
                            vm.requiredDocuments.wc.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.wc.approvedAttachments = [];
                        vm.requiredDocuments.wc.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve WC Attachment", "Error");
                    });
                    break;
                case 'CO':
                    vm.requiredDocuments.co.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.co.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.co.attachments.indexOf(attachment);
                        vm.requiredDocuments.co.attachments.splice(index,1);
                        if(vm.requiredDocuments.co.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.co.approvedAttachments[0];
                            vm.requiredDocuments.co.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.co.approvedAttachments = [];
                        vm.requiredDocuments.co.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve CO Attachment", "Error");
                    });
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.phyto.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.phyto.attachments.indexOf(attachment);
                        vm.requiredDocuments.phyto.attachments.splice(index,1);
                        if(vm.requiredDocuments.phyto.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.phyto.approvedAttachments[0];
                            vm.requiredDocuments.phyto.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.phyto.approvedAttachments = [];
                        vm.requiredDocuments.phyto.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Phyto Attachment", "Error");
                    });
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.wr.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.wr.attachments.indexOf(attachment);
                        vm.requiredDocuments.wr.attachments.splice(index,1);
                        if(vm.requiredDocuments.wr.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.wr.approvedAttachments[0];
                            vm.requiredDocuments.wr.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.wr.approvedAttachments = [];
                        vm.requiredDocuments.wr.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve WR Attachment", "Error");
                    });
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.ic.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.ic.attachments.indexOf(attachment);
                        vm.requiredDocuments.ic.attachments.splice(index,1);
                        if(vm.requiredDocuments.ic.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.ic.approvedAttachments[0];
                            vm.requiredDocuments.ic.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.ic.approvedAttachments = [];
                        vm.requiredDocuments.ic.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve IC Attachment", "Error");
                    });
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.sc.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.sc.attachments.indexOf(attachment);
                        vm.requiredDocuments.sc.attachments.splice(index,1);
                        if(vm.requiredDocuments.sc.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.sc.approvedAttachments[0];
                            vm.requiredDocuments.sc.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.sc.approvedAttachments = [];
                        vm.requiredDocuments.sc.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve SC Attachment", "Error");
                    });
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.fumigation.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.fumigation.attachments.indexOf(attachment);
                        vm.requiredDocuments.fumigation.attachments.splice(index,1);
                        if(vm.requiredDocuments.fumigation.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.fumigation.approvedAttachments[0];
                            vm.requiredDocuments.fumigation.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.fumigation.approvedAttachments = [];
                        vm.requiredDocuments.fumigation.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Fumigation Attachment", "Error");
                    });
                    break;
            }
        }

        vm.addCommentRequiredDocument = addCommentRequiredDocument;
        vm.editCommentRequiredDocument = editCommentRequiredDocument;
        vm.deleteCommentRequiredDocument = deleteCommentRequiredDocument;

        function resolveCommentsRequiredDocument(type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.purchaseInvoice.id).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Comments", "Error");
                    });
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.saleInvoice.id).then(function(data) {
                        vm.requiredDocuments.saleInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Comments", "Error");
                    });
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.icInvoice.id).then(function(data) {
                        vm.requiredDocuments.icInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Comments", "Error");
                    });
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.bl.id).then(function(data) {
                        vm.requiredDocuments.bl.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Comments", "Error");
                    });
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.pl.id).then(function(data) {
                        vm.requiredDocuments.pl.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Comments", "Error");
                    });
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.wc.id).then(function(data) {
                        vm.requiredDocuments.wc.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Comments", "Error");
                    });
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.co.id).then(function(data) {
                        vm.requiredDocuments.co.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Comments", "Error");
                    });
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.phyto.id).then(function(data) {
                        vm.requiredDocuments.phyto.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Comments", "Error");
                    });
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.wr.id).then(function(data) {
                        vm.requiredDocuments.wr.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Comments", "Error");
                    });
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.ic.id).then(function(data) {
                        vm.requiredDocuments.ic.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Comments", "Error");
                    });
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.sc.id).then(function(data) {
                        vm.requiredDocuments.sc.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Comments", "Error");
                    });
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.fumigation.id).then(function(data) {
                        vm.requiredDocuments.fumigation.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Comments", "Error");
                    });
                    break;
            }
        }

        function addCommentRequiredDocument(type) {
            var comment = [];
            switch(type) {
                case 'PURCHASEINVOICE':
                    if(vm.requiredDocuments.purchaseInvoice.id !== null && vm.rdComments.purchaseInvoice.length > 0) {
                        comment.push(createComment(vm.rdComments.purchaseInvoice));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.purchaseInvoice.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Purchase Invoice Document", "Success!");
                            vm.rdComments.purchaseInvoice = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'SALEINVOICE':
                    if(vm.requiredDocuments.saleInvoice.id !== null && vm.rdComments.saleInvoice.length > 0) {
                        comment.push(createComment(vm.rdComments.saleInvoice));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.saleInvoice.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Sale Invoice Document", "Success!");
                            vm.rdComments.saleInvoice = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'ICINVOICE':
                    if(vm.requiredDocuments.icInvoice.id !== null && vm.rdComments.icInvoice.length > 0) {
                        comment.push(createComment(vm.rdComments.icInvoice));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.icInvoice.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to IC Invoice Document", "Success!");
                            vm.rdComments.icInvoice = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'BL':
                    if(vm.requiredDocuments.bl.id !== null && vm.rdComments.bl.length > 0) {
                        comment.push(createComment(vm.rdComments.bl));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.bl.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to BL Document", "Success!");
                            vm.rdComments.bl = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'PL':
                    if(vm.requiredDocuments.pl.id !== null && vm.rdComments.pl.length > 0) {
                        comment.push(createComment(vm.rdComments.pl));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.pl.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to PL Document", "Success!");
                            vm.rdComments.pl = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'WC':
                    if(vm.requiredDocuments.wc.id !== null && vm.rdComments.wc.length > 0) {
                        comment.push(createComment(vm.rdComments.wc));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.wc.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to WC Document", "Success!");
                            vm.rdComments.wc = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'CO':
                    if(vm.requiredDocuments.co.id !== null && vm.rdComments.co.length > 0) {
                        comment.push(createComment(vm.rdComments.co));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.co.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to CO Document", "Success!");
                            vm.rdComments.co = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'PHYTO':
                    if(vm.requiredDocuments.phyto.id !== null && vm.rdComments.phyto.length > 0) {
                        comment.push(createComment(vm.rdComments.phyto));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.phyto.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Phyto Document", "Success!");
                            vm.rdComments.phyto = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'WR':
                    if(vm.requiredDocuments.wr.id !== null && vm.rdComments.wr.length > 0) {
                        comment.push(createComment(vm.rdComments.wr));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.wr.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to WR Document", "Success!");
                            vm.rdComments.wr = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'IC':
                    if(vm.requiredDocuments.ic.id !== null && vm.rdComments.ic.length > 0) {
                        comment.push(createComment(vm.rdComments.ic));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.ic.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to IC Document", "Success!");
                            vm.rdComments.ic = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'SC':
                    if(vm.requiredDocuments.sc.id !== null && vm.rdComments.sc.length > 0) {
                        comment.push(createComment(vm.rdComments.sc));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.sc.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to SC Document", "Success!");
                            vm.rdComments.sc = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'FUMIGATION':
                    if(vm.requiredDocuments.fumigation.id !== null && vm.rdComments.fumigation.length > 0) {
                        comment.push(createComment(vm.rdComments.fumigation));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.fumigation.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Fumigation Document", "Success!");
                            vm.rdComments.fumigation = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
            }
        }

        function editCommentRequiredDocument(index, type) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return returnCommentEntity(index, type);
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return RequiredDocument.get({id:returnRequiredDocumentId(type)}).$promise;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function(retVal) {
                updateCommentEntity(index, type, retVal);
            });
        }

        function deleteCommentRequiredDocument(index, type) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return returnCommentEntity(index, type);
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return RequiredDocument.get({id:returnRequiredDocumentId(type)}).$promise;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function(retVal) {
                if(retVal === true) {
                    spliceCommentEntity(index,type);
                }
            });
        }

        function returnCommentEntity(index, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    return vm.requiredDocuments.purchaseInvoice.comments[index];
                case 'SALEINVOICE':
                    return vm.requiredDocuments.saleInvoice.comments[index];
                case 'ICINVOICE':
                    return vm.requiredDocuments.icInvoice.comments[index];
                case 'BL':
                    return vm.requiredDocuments.bl.comments[index];
                case 'PL':
                    return vm.requiredDocuments.pl.comments[index];
                case 'WC':
                    return vm.requiredDocuments.wc.comments[index];
                case 'CO':
                    return vm.requiredDocuments.co.comments[index];
                case 'PHYTO':
                    return vm.requiredDocuments.phyto.comments[index];
                case 'WR':
                    return vm.requiredDocuments.wr.comments[index];
                case 'IC':
                    return vm.requiredDocuments.ic.comments[index];
                case 'SC':
                    return vm.requiredDocuments.sc.comments[index];
                case 'FUMIGATION':
                    return vm.requiredDocuments.fumigation.comments[index];
            }
        }

        function returnRequiredDocumentId(type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    return vm.requiredDocuments.purchaseInvoice.id;
                case 'SALEINVOICE':
                    return vm.requiredDocuments.saleInvoice.id;
                case 'ICINVOICE':
                    return vm.requiredDocuments.icInvoice.id;
                case 'BL':
                    return vm.requiredDocuments.bl.id;
                case 'PL':
                    return vm.requiredDocuments.pl.id;
                case 'WC':
                    return vm.requiredDocuments.wc.id;
                case 'CO':
                    return vm.requiredDocuments.co.id;
                case 'PHYTO':
                    return vm.requiredDocuments.phyto.id;
                case 'WR':
                    return vm.requiredDocuments.wr.id;
                case 'IC':
                    return vm.requiredDocuments.ic.id;
                case 'SC':
                    return vm.requiredDocuments.sc.id;
                case 'FUMIGATION':
                    return vm.requiredDocuments.fumigation.id;
            }
        }

        function updateCommentEntity(index, type, retVal) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments[index] = retVal;
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments[index] = retVal;
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments[index] = retVal;
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments[index] = retVal;
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments[index] = retVal;
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments[index] = retVal;
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments[index] = retVal;
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments[index] = retVal;
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments[index] = retVal;
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments[index] = retVal;
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments[index] = retVal;
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments[index] = retVal;
                    break;
            }
        }

        function spliceCommentEntity(index, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments.splice(index,1);
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments.splice(index,1);
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments.splice(index,1);
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments.splice(index,1);
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments.splice(index,1);
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments.splice(index,1);
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments.splice(index,1);
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments.splice(index,1);
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments.splice(index,1);
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments.splice(index,1);
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments.splice(index,1);
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments.splice(index,1);
                    break;
            }
        }
        //========================End of Shipment Document========================
        //####################################################################
        //========================Start of Other Functions=========================
        //fancy way to select all text inside input box on click
        function onTextClick($event) {
            $event.target.select();
        }

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }

        function resolveDates() {
            vm.shipment.siDate = MiscService.dateFix(vm.shipment.siDate);
            if (vm.shipment.originEtd !== null) {
                vm.shipment.originEtd = MiscService.dateFix(vm.shipment.originEtd);
            }
            if (vm.shipment.destEta !== null) {
                vm.shipment.destEta = MiscService.dateFix(vm.shipment.destEta);
            }
            if (vm.shipment.cutoff !== null) {
                vm.shipment.cutoff = MiscService.dateFix(vm.shipment.cutoff);
            }
            if (vm.shipment.freightPaymentDate !== null) {
                vm.shipment.freightPaymentDate = MiscService.dateFix(vm.shipment.freightPaymentDate);
            }
            if (vm.shipment.lcDate !== null) {
                vm.shipment.lcDate = MiscService.dateFix(vm.shipment.lcDate);
            }
            if (vm.shipment.boeDate !== null) {
                vm.shipment.boeDate = MiscService.dateFix(vm.shipment.boeDate);
            }
            if (vm.shipment.lcExpiry !== null) {
                vm.shipment.lcExpiry = MiscService.dateFix(vm.shipment.lcExpiry);
            }
            if (vm.shipment.lcLatestShipment !== null) {
                vm.shipment.lcLatestShipment = MiscService.dateFix(vm.shipment.lcLatestShipment);
            }
            if (vm.shipment.blDate !== null) {
                vm.shipment.blDate = MiscService.dateFix(vm.shipment.blDate);
            }
        }

        function resolveLots() {
            if (vm.shipment.id) {
                LotCustomService.returnMinifiedLotsByShipment(vm.shipment.id).then(function (data) {
                    vm.lots = data.data;
                    resolveLotData();
                }, function (error) {
                    if (error.status !== "404") {
                        ToastrService.error("Cannot get Lots for this Shipment", "Error!");
                    }
                    console.log(error.message);
                });
            }
        }

        function resolveALot(lot) {
            var promlist = [];
            if (vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined) {
                lot.allocSale = vm.shipment.saleContract;
                if (vm.shipment.id !== null) {
                    lot.allocSi = vm.shipment;
                }
            }
            promlist.push(ContractCustomService.returnPurchaseContractByLot(lot.id));
            if (vm.shipment.id !== null) {
                lot.purchSi = vm.shipment;
            }
            return $q.all(promlist).then(function (data) {
                lot.purchase = data[0].data;
                return lot;
            }).then(function () {
                return lot;
            });
        }

        function resolveComments() {
            vm.comments.length = 0;
            CommentCustomService.returnCommentsByShipment(vm.shipment.id).then(function (data) {
                vm.comments = data.data;
                // if( vm.comments.length > 0 ) {
                //     ToastrService.success("Grabbed Existing Comments", "Success!");
                // }
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Failed to fetch existing comments", "Error!");
                }
                console.log( error.message );
            });
        }

        function resolveAttachments() {
            AttachmentCustomService.returnAttachmentsByShipment(vm.shipment.id).then(function (data) {
                vm.attachments = data.data;
                // if( vm.attachments.length > 0 ) {
                //     ToastrService.success("Grabbed Existing Attachments", "Success!");
                // }
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Failed to fetch existing attachments: " + error.statusText, "Error!");
                }
                console.log( error.statusText );
            });
        }

        //========================End of Other Functions===========================
        //####################################################################
        //========================Start of Unused Functions========================
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            // $uibModalInstance.dismiss('cancel');
        }

        //Deprecated -- everything is done at the backend -- might still be useful in the future
        $scope.resolveQtyDisplay = function () {
            if (vm.shipment.qtyUnitType && vm.shipment.quantity) {
                vm.shipment.qtyDisplay = vm.shipment.quantity + " " + vm.shipment.qtyUnitType;
                vm.altQty = calcAltQty();
            }
        };

        //Deprecated -- everything is done at the backend -- might still be useful in the future
        function calcAltQty() {
            if (vm.shipment.qtyUnitType && vm.shipment.quantity) {
                switch (vm.shipment.qtyUnitType) {
                case 'BALES':
                    vm.shipment.qtyBales = vm.shipment.quantity;
                    vm.shipment.qtyLbs = Math.round((vm.shipment.quantity * 501.05) * 100) / 100;
                    vm.shipment.qtyKgs = Math.round((vm.shipment.qtyLbs / 2.2046) * 100) / 100;
                    vm.shipment.qtyMts = Math.round((vm.shipment.qtyKgs / 1000) * 10) / 10;
                    return 'About ' + numeral(vm.shipment.quantity * 501.05).format('0,0.00') + ' LBS';
                    break;
                case 'MTS':
                    vm.shipment.qtyKgs = Math.round((vm.shipment.quantity * 1000) * 100) / 100;
                    vm.shipment.qtyLbs = Math.round((vm.shipment.quantity * 2204.6) * 100) / 100;
                    vm.shipment.qtyMts = Math.round((vm.shipment.quantity) * 10) / 10;
                    vm.shipment.qtyBales = Math.round((vm.shipment.qtyLbs / 501.05) * 10) / 10;
                    return 'About ' + numeral(vm.shipment.quantity * 2204.6).format('0,0.00') + ' LBS';
                    break;
                }
            }
        }
        //========================End of Unused Functions========================

        vm.blFromList = [];
        vm.blToList = [];
        // KeywordCustomService.returnKeywordsByType("BL From").then( function( data ) {
        KeywordCustomService.returnMinifiedKeywordsByType("BL From").then( function( data ) {
            vm.blFromList = data.data;
            // if( vm.blFromList.length > 0 ) {
            //     ToastrService.success( "Grabbed Shipment BL From List Success", "Success!" );
            // }
        }, function( error ) {
            if( error.status !== "404" ) {
                ToastrService.error( "Failed to get Shipment BL From List", "Error!" );
            }
            console.log( error.message );
        });
        // KeywordCustomService.returnKeywordsByType("BL To").then( function( data ) {
        KeywordCustomService.returnMinifiedKeywordsByType("BL To").then( function( data ) {
            vm.blToList = data.data;
            // if( vm.blToList.length > 0 ) {
            //     ToastrService.success( "Grabbed Shipment BL To List Success", "Success!" );
            // }
        }, function( error ) {
            if( error.status !== "404" ) {
                ToastrService.error( "Failed to get Shipment BL To List", "Error!" );
            }
            console.log( error.message );
        });

        vm.onTextClick = function( $event ) {
            $event.target.select();
        };

        vm.resolveWeightData = resolveWeightData;
        vm.resetWeights = resetWeights;
        vm.assignWeights = assignWeights;
        vm.updateLot = updateLot;

        function resolveWeightData(lot) {
            if (!lot.purchWtType) {
                lot.purchWtType = 'MT';
            }

            var weightData = {};
            switch(lot.purchWtType) {
            case 'KG':
                //actual weights holder
                weightData.actualWeightNet = lot.purchNetKgs;
                weightData.actualWeightGross = lot.purchGrossKgs;
                weightData.actualWeightTare = lot.purchTareKgs;
                //landed weights holder
                weightData.landedWeightNet = lot.purchLandedNetKgs;
                weightData.landedWeightGross = lot.purchLandedGrossKgs;
                weightData.landedWeightTare = lot.purchLandedTareKgs;
                break;
            case 'LB':
                //actual weights holder
                weightData.actualWeightNet = lot.purchNetLbs;
                weightData.actualWeightGross = lot.purchGrossLbs;
                weightData.actualWeightTare = lot.purchTareLbs;
                //landed weights holder
                weightData.landedWeightNet = lot.purchLandedNetLbs;
                weightData.landedWeightGross = lot.purchLandedGrossLbs;
                weightData.landedWeightTare = lot.purchLandedTareLbs;
                break;
            case 'MT':
                //actual weights holder
                weightData.actualWeightNet = lot.purchNetMTs;
                weightData.actualWeightGross = lot.purchGrossMTs;
                weightData.actualWeightTare = lot.purchTareMTs;
                //landed weights holder
                weightData.landedWeightNet = lot.purchLandedNetMTs;
                weightData.landedWeightGross = lot.purchLandedGrossMTs;
                weightData.landedWeightTare = lot.purchLandedTareMTs;
                break;
            }
            weightData.actualWeightAvg = lot.actualWtAvg;
            weightData.landedWeightAvg = lot.landedWtAvg;
            weightData.actualWeightGrossAvg = lot.actualWtGrossAvg;
            weightData.landedWeightGrossAvg = lot.landedWtGrossAvg;
            weightData.actualWeightTareAvg = lot.actualWtTareAvg;
            weightData.landedWeightTareAvg = lot.landedWtTareAvg;
            return weightData;
        }

        function calculateAvgNet(lot) {
            if (isNaN(lot.qtyBales) || lot.qtyBales === null || lot.qtyBales === '' || lot.qtyBales === undefined) {
                lot.qtyBales = 1;
            }
            var weightData = vm.resolveWeightData(lot);
            var avgData = {};
            //set actual avgs
            var actualTare = weightData.actualWeightGross - weightData.actualWeightNet;
            avgData.actualWeightAvg = Math.round((weightData.actualWeightNet / lot.qtyBales) * 100) / 100;
            avgData.actualWeightGrossAvg = Math.round((weightData.actualWeightGross / lot.qtyBales) * 100) / 100;
            avgData.actualWeightTareAvg = Math.round((actualTare / lot.qtyBales) * 100) / 100;
            lot.actualWtAvg = avgData.actualWeightAvg;
            lot.actualWtGrossAvg = avgData.actualWeightGrossAvg;
            lot.actualWtTareAvg = avgData.actualWeightTareAvg;
            //set landed avgs
            var landedTare = weightData.landedWeightGross - weightData.landedWeightNet;
            avgData.landedWeightAvg = Math.round((weightData.landedWeightNet / lot.qtyBales) * 100) / 100;
            avgData.landedWeightGrossAvg = Math.round((weightData.landedWeightGross / lot.qtyBales) * 100) / 100;
            avgData.landedWeightTareAvg = Math.round((landedTare / lot.qtyBales) * 100) / 100;
            lot.landedWtAvg = avgData.landedWeightAvg;
            lot.landedWtGrossAvg = avgData.landedWeightGrossAvg;
            lot.landedWtTareAvg = avgData.landedWeightTareAvg;
            if (lot.purchWtType !== "" || lot.purchWtType !== null || lot.purchWtType !== undefined) {
                assignWeights(lot, weightData);
            }
        }

        function assignWeights(lot, weightData) {
            var actualNet = weightData.actualWeightNet;
            var actualGross = weightData.actualWeightGross;
            var actualTare = Math.round((actualGross - actualNet) * 100) / 100;
            weightData.actualWeightTare = actualTare;
            var landedNet = weightData.landedWeightNet;
            var landedGross = weightData.landedWeightGross;
            var landedTare = Math.round((landedGross - landedNet) * 100) / 100;
            weightData.landedWeightTare = landedTare;

            switch (lot.purchWtType) {
            case 'KG':
                //actual
                lot.purchNetKgs = actualNet;
                lot.purchGrossKgs = actualGross;
                lot.purchTareKgs = actualTare;
                //landed
                lot.purchLandedNetKgs = landedNet;
                lot.purchLandedGrossKgs = landedGross;
                lot.purchLandedTareKgs = landedTare;
                //lot weight kgs
                lot.lotWeightKgs = landedNet;
                break;
            case 'LB':
                //actual
                lot.purchNetLbs = actualNet;
                lot.purchGrossLbs = actualGross;
                lot.purchTareLbs = actualTare;
                //landed
                lot.purchLandedNetLbs = landedNet;
                lot.purchLandedGrossLbs = landedGross;
                lot.purchLandedTareLbs = landedTare;
                //lot weight lbs
                lot.lotWeightLbs = landedNet;
                break;
            case 'MT':
                //actual
                lot.purchNetMTs = actualNet;
                lot.purchGrossMTs = actualGross;
                lot.purchTareMTs = actualTare;
                //landed
                lot.purchLandedNetMTs = landedNet;
                lot.purchLandedGrossMTs = landedGross;
                lot.purchLandedTareMTs = landedTare;
                //lot weight mts
                lot.lotWeightMts = landedNet;
                break;
            }
            lot.lotWeightDisplay = landedNet + " " + lot.purchWtType;
        }

        function resetWeights(lot, wtType) {
            switch (wtType) {
            case 'KG':
                //actual
                lot.purchNetKgs = 0;
                lot.purchGrossKgs = 0;
                lot.purchTareKgs = 0;
                //landed
                lot.purchLandedNetKgs = 0;
                lot.purchLandedGrossKgs = 0;
                lot.purchLandedTareKgs = 0;
                //lot weight
                lot.lotWeightKgs = 0;
                break;
            case 'LB':
                //actual
                lot.purchNetLbs = 0;
                lot.purchGrossLbs = 0;
                lot.purchTareLbs = 0;
                //landed
                lot.purchLandedNetLbs = 0;
                lot.purchLandedGrossLbs = 0;
                lot.purchLandedTareLbs = 0;
                //lot weight
                lot.lotWeightLbs = 0;
                break;
            case 'MT':
                //actual
                lot.purchNetMTs = 0;
                lot.purchGrossMTs = 0;
                lot.purchTareMTs = 0;
                //landed
                lot.purchLandedNetMTs = 0;
                lot.purchLandedGrossMTs = 0;
                lot.purchLandedTareMTs = 0;
                //lot weight
                lot.lotWeightMts = 0;
                break;
            }
        }

        function updateLot(lot, index) {
            vm.calculateAvgNet(lot);
            Lot.update(lot, function( result ) {
                ToastrService.success("Successfully Updated Lot Weight", "Success");
                if( vm.shipment.id ) {
                    resolveLots();
                } else {
                    var prom = resolveALot(result);
                    prom.then(function( data ){
                        vm.lots[index] = data;
                        countBales();
                    });
                }
            }, function (error) {
                ToastrService.error("Cannot Update Lot Weight: " + error.statusText, "Error");
                // resolveLots();
                countBales();
            });
        }

        /*
        Landing Reports Stuff
         */
        //landing report actions
        vm.lrs = [];
        vm.deleteTempLr = deleteTempLr;
        vm.downloadLr = downloadLr;
        vm.deleteLr = deleteLr;

        $scope.lrs = [];
        $scope.uploadLandingReports = function (file) {
            if (file && file.length) {
                angular.forEach(file, function (file) {
                    $scope.lrs.push(file);
                    if (vm.shipment.id !== null) {
                        AttachmentCustomService.uploadAttachment(file, "lr", vm.shipment.id, file.name).then(function (data) {
                            vm.lrs.push(data.data);
                            ToastrService.success("Successfully uploaded Landing Report", "Success");
                        }, function (error) {
                            if (error.status !== 404) {
                                ToastrService.error("Cannot upload Landing Report: " + error.statusText, "Error");
                            }
                            console.log(error.statusText);
                        });
                        var index = $scope.lrs.indexOf(file);
                        $scope.lrs.splice(index, 1);
                    }
                });
            }
        };

        function deleteTempLr( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-remove-modal.html',
                controller: 'AttachmentRemoveModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return $scope.lrs[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    $scope.lrs.splice( index, 1 );
                    ToastrService.success("Successfully removed Landing Report", "Success!");
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function downloadLr( lr ) {
            AttachmentCustomService.downloadAttachment( lr.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, lr.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Something went wrong: " + error.statusText, "Error");
                    console.log( error.statusText );
                }
            });
        }

        function deleteLr( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.lrs[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    vm.lrs.splice( index, 1 );
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function resolveLrs() {
            AttachmentCustomService.returnAttachmentsByLr( vm.shipment.id ).then( function( data ) {
                vm.lrs = data.data;
                // if( vm.lrs.length > 0 ) {
                //     ToastrService.success("Fetched Landing Reports", "Success!");
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot fetch Landing Reports: " + error.statusText, "Error" );
                }
                console.log( error.statusText );
            });
        }

        var tmbt = ['','THOUSAND','MILLION', 'BILLION','TRILLION'];
        var kids = ['ZERO','ONE','TWO','THREE','FOUR','FIVE','SIX','SEVEN','EIGHT','NINE'];
        var teens =['TEN','ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'];
        var adults = ['TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];
        function toWords(s){
            s = s.toString(); s = s.replace(/[\, ]/g,'');
            if (s != parseFloat(s)) return 'not a number';
            var x = s.indexOf('.');
            if (x == -1) x = s.length;
            if (x > 15) return 'number is too big';
            var n = s.split('');
            var str = '';
            var sk = 0;
            for (var i=0; i < x; i++) {
                if ((x-i)%3==2) {
                    if (n[i] == '1') {
                        str += teens[Number(n[i+1])] + ' '; i++; sk=1;
                    }
                    else if (n[i]!=0) {
                        str += adults[n[i]-2] + ' ';sk=1;
                    }
                } else if (n[i]!=0) {
                    str += kids[n[i]] +' ';
                    if ((x-i)%3==0) str += 'HUNDRED ';sk=1;
                } if ((x-i)%3==1) {
                    if (sk) str += tmbt[(x-i-1)/3] + ' ';sk=0;
                }
            }
            if( x != s.length ) {
                var y = s.length;
                str += "AND ";
                if(y - x === 2) {
                    if(s[x+1] == '0') {
                        str += kids[s[x+1]] + ' ';
                    } else if(s[x+1] == '1') {
                        str += teens[s[x+1]-1] + ' ';
                    } else {
                        str += adults[s[x+1]-2] + ' ';
                    }
                } else {
                    for(var i=x+1; i < y; i++) {
                        if ((y-i)%3==2) {
                            if (s[i] == '1') {
                                str += teens[Number(s[i+1])] + ' '; i++; sk=1;
                            }
                            else if (s[i]!=0) {
                                str += adults[s[i]-2] + ' ';sk=1;
                            }
                        } else if (s[i]!=0) {
                            str += kids[s[i]] +' ';
                            if ((y-i)%3==0) str += 'HUNDRED ';sk=1;
                        } if ((y-i)%3==1) {
                            if (sk) str += tmbt[(y-i-1)/3] + ' ';sk=0;
                        }
                    }
                }
                str += "CENTS";
            }
            return str;
        }

        function setScale(value, scale) {
            return parseFloat(value).toFixed(scale);
        }

        $scope.$watch("vm.shipment.boeTenor", function(newValue, oldValue) {
            vm.shipment.paymentTerms = vm.shipment.boeTenor;
        });

        $scope.resolveIncoTermsDisplay = function() {
            if( vm.shipment.incoTerms && vm.shipment.incoTerms !== null ) {
                vm.shipment.incoTermsDisplay = vm.shipment.incoTerms;
            }
        }

        $scope.resolveIncoTermsNContractDisplay = function() {
            if(vm.shipment.incoTermsNContract && vm.shipment.incoTermsNContract !== null) {
                vm.shipment.incoTermsNContractDisplay = vm.shipment.incoTermsNContract;
            }
        }
    }
})();
